import Util, { MeshUserData, PanelStoreData, constants, defaultPanelConfigObj, meshTypeEnum, renderOrders, storeIdPrefix, threeColors, vertexType } from "./Utility";
import { Vector3, Plane, Line, BufferGeometry, LineBasicMaterial, Mesh, Object3D, BoxGeometry, MeshBasicMaterial, Matrix4, Quaternion, BufferAttribute, DoubleSide, Box3, SphereGeometry, MeshPhysicalMaterial, Shape, Vector2, ShapeGeometry, Intersection, Group, PlaneGeometry, MathUtils, Texture, MeshStandardMaterial, Color, AxesHelper, Material, TextureLoader, InstancedMesh, SRGBColorSpace, MeshPhongMaterial, ShaderMaterial, UniformsUtils, UniformsLib, DirectionalLight, Raycaster } from 'three';
import { fromRoofSectionSelectors } from "@design/store/roof-section";
import { RoofSection, flatRoofDefaults } from "@design/models/roof-section.model";
import { Vertex } from "@design/models/vertex.model";
import { Store } from "@ngrx/store";

import { DesignState } from "@design/store/design.reducer";
import { filter, map, switchMap, take } from "rxjs/operators";
import { fromVertexSelectors } from "@design/store/vertex";
import { Edge } from "@design/models/edge.model";
import { StoreUtil } from "./StoreUtil";
import { panelDims } from "./Utility";
import { fromObstacleSelectors } from "@design/store/obstacle";
import { Obstacle, ObstacleType } from "@design/models/obstacle.model";
import { fromDesignComponentSelectors } from "@design/store/design-component";
import { MountingType } from "@design/models/design-component.model";
import DebugUtil from "./DebugUtil";
import { openNotificationService } from "@lib-ui/lib/atomic/enact-alert-snack-bar/openNotification.service";
import { fromMetaDataActions, fromMetaDataSelectors } from "@design/store/meta-data";
import { ArrayAlignment, PanelArray } from "@design/models/panel-array.model";
import { Frame } from "@design/models/frame.model";
import { AuthService } from "src/app/helpers/auth.service";
import { PanelconfigService } from "src/app/modules/system-design/panelconfig/panelconfig.service";
import { PanelTypeVO } from "src/app/modules/system-design/panelconfig/inetrfaces/panel-type-vo";
import { Panel, PanelOrientation } from "@design/models/panel.model";
import { ConfigurationIds } from "@design/models/ui-state.model";
import { fromPanelActions } from "@design/store/panel";
import { fromPanelArraySelectors } from "@design/store/panel-array/panel-array.selector";
import { EngineService } from "../threejs.service";
import { NotificationType } from "@lib-ui/lib/atomic/enact-alert-snack-bar/notification.message";
import { fromUiActions } from "@design/store/ui";
import { fromPanelArrayActions } from "@design/store/panel-array";
import { PanelArrayCursors } from "./cursors/cursorHelper";
import { Edges } from "./Edges";
import { fromPanelSelectors } from "@design/store/panel/panel.selector";
import { fromFrameSelectors } from "@design/store/frame/frame.selector";
import { fromFrameActions } from "@design/store/frame";
import { TranslateService } from "@ngx-translate/core";
import { calculateAzimuth2, DefaultFrameValues } from "src/app/helpers/utils";
import { Injectable } from "@angular/core";
import { forkJoin, Subscription } from "rxjs";
import { SubscriptionManager } from "../services/subscription-manager.service";
import { SceneStoreSyncService } from '@design/services/scene-store-sync.service';
import CollisionUtil from "../utils/collision.util";
import { fromUndoRedoActions } from "@design/store/undo-redo/undo-redo.action";
import { InstancedMeshUtil, PanelTextureEnum } from "../utils/instanceMesh.util";
import { StructureGeometryService } from "./StructureGeometryService";
import { ObstacleEffects } from "@design/store/obstacle/obstacle.effect";
import { fromAdditionalToolsActions, fromAdditionalToolsResultsSelectors } from "@design/store/additional-tools";
import { fromEdgeSelectors } from "@design/store/edge";

@Injectable({ providedIn: 'root' })
export class PanelGeometry {   
    private offsetFromRoof: number = 0.1; // offset obstacle from toof for better visibility
    private defaultInterRowSpace = 1.64042 // value in feet
    private roofOverhangAllowance: number = 0; // fraction of panel depth that can overhang the roof edge, loaded from user preferences (0–0.9)
    private panelGroupObj: Object3D = new Object3D();
    private firstVertexMaterial: MeshBasicMaterial = new MeshBasicMaterial({ color: threeColors.firstVertex });
    public selectedBlock: Object3D | null = null;
    private currPoint: Vector3 = new Vector3();
    private prevPoint: Vector3 = new Vector3();
    private currentLine: Line | undefined;
    private drawEdgeList: Line[] = [];
    private drawPanelGeom: Mesh | undefined;
    private drawPanelShape: Shape | undefined;
    public tempVertex: Mesh = Util.createVertex(vertexType.spherical);
    public drawVertexList: Mesh[] = [];
    public guidesGroup: Group = new Group();
    public fillActive: boolean = false;
    public drawActive: boolean = false;
    public singlePanelActive: boolean = false;
    private temporaryTransparentPanel?: Mesh;
    private allObstacles: Obstacle[] = [];
    private isSinglePanelRotated: boolean = false;
    private storeUtil: StoreUtil;
    // private storeRoof: RoofSection | undefined;
    localeToSolarTiltAngelObj: PanelTypeVO[] = [];

    private defaultPanelConfigObj: PanelArray = Object.assign({}, defaultPanelConfigObj);
    public edgeObj: Edges;
    private debugUtil: DebugUtil = new DebugUtil()
    private invalidSinglePanel!: boolean;
    private lastSinglePanelRoofPlane: Mesh | null = null;
    private cursorState!: PanelArrayCursors ;
    private subscription: Subscription = new Subscription();
    private loader = new TextureLoader();
    private defaultPanelMaterial!: MeshStandardMaterial;
    private panelTexture = this.loader.load(
        "./assets/threejs/Solar-panel-texture.png",
        texture => {
          texture.center = new Vector2(0.5, 0.5);
          texture.colorSpace = SRGBColorSpace;
        },
        (progress) => { },
        (error) => {
          console.error("unable to load panel texture", error);
        }

      );
      private panelWhiteTexture = this.loader.load("./assets/threejs/White.png", (texture) => {
        texture.center = new Vector2(0.5, 0.5);
        texture.colorSpace = SRGBColorSpace;
      },
        undefined,
        (error) => {
          throw error;
        }
      );

    panelWhiteTexture2 = this.loader.load("./assets/threejs/Shade_panel.png", (texture) => {
        texture.center = new Vector2(0.5, 0.5);
    },
        undefined,
        (error) => {
            throw error;
        }
    );

    // Panel translucency state for obstacle/walkway mode
    private readonly panelObstacleOpacity = 0.4;
    private panelsTranslucent = false;
    private readonly panelTranslucencyMeshTypes = new Set<string>([
        meshTypeEnum.instancedMesh,
        meshTypeEnum.panelMesh,
        meshTypeEnum.singlePanel,
    ]);

      private panelRedTexture = this.loader.load("./assets/threejs/Red.png", (texture) => {
        texture.center = new Vector2(0.5, 0.5);
        texture.colorSpace = SRGBColorSpace;
      },
        undefined,
        (error) => {
          throw error;
        }
      );
      private panelYellowTexture = this.loader.load("./assets/threejs/Yellow.png", (texture) => {
        texture.center = new Vector2(0.5, 0.5);
        texture.colorSpace = SRGBColorSpace;
      },
        undefined,
        (error) => {
          throw error;
        }
      );
    defaultPanelArrayModule!: PanelArray;
    continousPanelCount: number = 0;

    constructor(
        private structureGeometryService: StructureGeometryService,
        private subscriptionManager: SubscriptionManager,
        private store: Store<DesignState>,
        private notificationService: openNotificationService,
        private authService: AuthService,
        private panelconfigService: PanelconfigService,
        private engServ: EngineService,
        private translate : TranslateService,
        private sceneStoreSyncService: SceneStoreSyncService
    ) {
        this.subscriptionManager.getSubscription().subscribe((subscribe: any)=>{
            if(subscribe){
                this.subscription = new Subscription();
                this.initSubscriptions();
            }else{
                this.subscription.unsubscribe();
            }
        })
        this.storeUtil = new StoreUtil(this.store, this.notificationService, this.engServ, this.translate, this.sceneStoreSyncService);
        InstancedMeshUtil.loadPanelTextures();
        this.edgeObj = new Edges();
    }

    initSubscriptions(){
        this.subscription.add(this.getAllObstacles());
        this.subscription.add(this.getDefaultModule());
        this.subscription.add(this.getLocaleToSolarTiltAngels());
        this.subscription.add(this.getSinglePanelContinousCount());
        this.subscription.add(this.loadRoofOverhangPreference());
        
        // Add smart validation that triggers after idle periods
        this.subscription.add(this.setupSmartValidation());
    }
    
    public getRoofOverhangAllowance(): number {
        return this.roofOverhangAllowance;
    }

    /**
     * Loads the roof overhang allowance from account preferences.
     * Preference key: `system_design.maxPanelOverhangPercent` (value as a percentage 0–90).
     */
    private loadRoofOverhangPreference(): Subscription {
        return this.store.select(fromMetaDataSelectors.selectPreference)
            .pipe(
                filter(obj => obj != null),
                take(1)
            )
            .subscribe((obj: any) => {
                const preferencesObj = obj?.preferencesObj;
                const overhangValue = preferencesObj?.system_design?.maxPanelOverhangPercent?.value;
                if (overhangValue !== undefined && overhangValue !== null) {
                    // Preference is stored as a percentage (0–90); convert to fraction and clamp
                    const fraction = Number(overhangValue) / 100;
                    this.roofOverhangAllowance = Math.min(Math.max(fraction, 0), 0.9);
                } else {
                    this.roofOverhangAllowance = 0;
                }
            });
    }

    /**
     * sets up validation that only runs when the system is idle
     */
    private setupSmartValidation(): Subscription {
        // Only validate when certain store changes occur that might affect visibility
        return this.store.select(fromPanelArraySelectors.allPanelArrays).subscribe(() => {
            if (this.validationTimeout) {
                clearTimeout(this.validationTimeout);
            }
            this.validationTimeout = setTimeout(() => {
                this.validateAndFixVisibilitySyncAsync()
                    .catch(error => console.error('Error in smart validation:', error));
            }, 2000); 
        });
    }

    private validationTimeout?: ReturnType<typeof setTimeout>;

    /**
     * Cleanup method to clear timeouts and subscriptions
     */
    public cleanup() {
        if (this.validationTimeout) {
            clearTimeout(this.validationTimeout);
            this.validationTimeout = undefined;
        }
        this.subscription.unsubscribe();
    }

    getSinglePanelContinousCount() {
        this.store.select(fromAdditionalToolsResultsSelectors.getContinousPanelCount).subscribe(count=>{
            this.continousPanelCount = count;
        })
    }

    getAllObstacles(): Subscription{
        return this.store
            .select(fromObstacleSelectors.allObstacles)
            .subscribe((v) => {
              this.allObstacles = JSON.parse(JSON.stringify(v));
            });
    }

    getDefaultModule(): Subscription{
        return this.store
        .select(fromMetaDataSelectors.getDefaultModule)
        .subscribe((metadata: PanelArray) => {

            if (metadata) {
                // update default values with the values from store
                this.defaultPanelArrayModule = metadata;
            } else {
                // // this happens typically on page load - because of the sequence of calls - the store gets updated after this constructuor is called
                console.error("Unable to identify default Panel Array module -(ignore if triggered on page load)")
            }
        });
    }

    updateModule(){
        Util.overrideObjWithNewValues(this.defaultPanelConfigObj, this.defaultPanelArrayModule);
        this.defaultPanelConfigObj.panelWidth = this.defaultPanelArrayModule.panelWidth ?? panelDims.WIDTH;
        this.defaultPanelConfigObj.panelLength = this.defaultPanelArrayModule.panelLength ?? panelDims.LENGTH;
    }

    activateFill() {
        this.fillActive = true;
        this.panelGroupObj = new Object3D();
        this.panelGroupObj.name = "panelFill_";
    }

    deactivateFill() {
        this.fillActive = false;
        this.defaultPanelConfigObj = Object.assign({}, defaultPanelConfigObj);
    }
    activateDraw() {
        this.drawActive = true;
        this.panelGroupObj = new Object3D();
        this.panelGroupObj.name = "panelDraw_";
    }

    deactivateDraw() {
        this.drawActive = false;
        this.defaultPanelConfigObj = Object.assign({}, defaultPanelConfigObj); // To do: test it
    }

    terminatePanelDraw() {
        Util.removeObjWithChildren(this.panelGroupObj);
        this.store.dispatch(fromUiActions.ClearSelection());
        this.deactivateDraw();
    }

    activateSinglePanel() {
        this.singlePanelActive = true;
        // Panel draw logic is changes to support single panels, Which need old panels to be redrawn.
        this.reDrawOldPanelsArrays();
        this.guidesGroup = new Group();
        this.guidesGroup.name = meshTypeEnum.guidesGroup;
        this.engServ.scene.add(this.guidesGroup)
    }

    reDrawOldPanelsArrays() {
        this.store.select(fromPanelArraySelectors.allPanelArrays).pipe(take(1)).subscribe(panelArrays => {
            if (panelArrays && panelArrays.length) {
                panelArrays.forEach((panelStore: PanelArray) => {
                    const panelArray = JSON.parse(JSON.stringify(panelStore));
                    const panelArrObject = this.engServ.scene.getObjectByName(panelStore.id);
                    if(panelArrObject && panelArrObject.children.length && ((panelArrObject.children[0].userData as MeshUserData).meshtype != meshTypeEnum.instancedMesh)){
                    //if(panelStore.panelTilt > 0){
                        this.store.dispatch(fromMetaDataActions.setChangeFieldName({ prevState: { field: "interrowspacing", value: 10 } }));
                        this.store.dispatch(fromPanelArrayActions.PanelArrayConfigurationChangeTry({ panelArray: panelArray }));
                    //}
                    }
                })
            }
        })
    }

    removeTemporaryPanel() {
        if (this.temporaryTransparentPanel) {
            (this.temporaryTransparentPanel?.material as MeshStandardMaterial).dispose();
            Util.removeObjWithChildren(this.temporaryTransparentPanel);
        }
        this.engServ.scene.getObjectsByProperty('name', meshTypeEnum.temporaryPanelMesh).forEach(m => { Util.removeObjWithChildren(m) });
        this.temporaryTransparentPanel = undefined;
    }

    deactivateSinglePanel() {
        this.singlePanelActive = false;
        this.removeTemporaryPanel();
        this.guidesGroup.removeFromParent().clear();
        this.isSinglePanelRotated = false;
        this.lastSinglePanelRoofPlane = null;
    }

    terminateSinglePanel() {
        this.store.dispatch(fromUiActions.ClearSelection());
        this.deactivateSinglePanel();
        this.guidesGroup.removeFromParent().clear();
        this.isSinglePanelRotated = false;
        this.continousPanelCount = 0;
        this.store.dispatch(fromAdditionalToolsActions.SetContinousPanelCount({continousPanelCount: this.continousPanelCount}));
    }

    /**
     * Sets all panels to translucent (40% opacity) or restores them to full opacity.
     * Used during obstacle/walkway workflows so obstacles render clearly above panels.
     * @param enable true to make panels 40% translucent, false to restore 100% opacity
     */
    public setPanelsTranslucent(enable: boolean): void {
        const targetOpacity = enable ? this.panelObstacleOpacity : 1;

        // Update the global shader uniform for InstancedMesh panels
        InstancedMeshUtil.setGlobalPanelOpacity(targetOpacity);
        
        this.panelsTranslucent = enable;

        // Also update non-instanced panel meshes if any exist
        if (this.engServ.scene) {
            this.engServ.scene.traverse((object: Object3D) => {
                const meshType = (object.userData as MeshUserData)?.meshtype;
                if (meshType && this.panelTranslucencyMeshTypes.has(meshType)) {
                    // Skip pillar/racking meshes — only panels should be translucent
                    if (object.name === meshTypeEnum.pillerArray) return;
                    this.applyOpacityToPanelObject(object, targetOpacity);
                }
            });
        }
    }

    private applyOpacityToPanelObject(object: Object3D, opacity: number): void {
        if (object instanceof InstancedMesh) {
            this.updatePanelMaterialOpacity(object.material, opacity);
        } else if (object instanceof Mesh) {
            this.updatePanelMaterialOpacity(object.material, opacity);
        }
    }

    private updatePanelMaterialOpacity(material: Material | Material[], opacity: number): void {
        const update = (mat: Material | undefined) => {
            if (!mat) {
                return;
            }
            // Always set transparent to true for proper blending
            mat.transparent = true;
            mat.opacity = opacity;
            // Set depthWrite based on opacity - disable when translucent for proper rendering
            mat.depthWrite = opacity >= 1;
            mat.needsUpdate = true;
        };

        if (Array.isArray(material)) {
            material.forEach(update);
            return;
        }

        update(material);
    }

    getPanelMesh(instancedMesh: InstancedMesh) {
      const panelArrayId = instancedMesh.parent?.name;
      let panelConfig: PanelArray;
      this.store.select(fromPanelArraySelectors.selectPanelArraysByIds([panelArrayId!])).pipe(take(1)).subscribe(arrayy=>{
        if(arrayy.length<=0) return;
        panelConfig = arrayy[0]!;
      })
      const matrix = new Matrix4();
      instancedMesh.getMatrixAt(0, matrix);
      const panelGeom = new PlaneGeometry( Util.getMeasurementFeetToPixel(panelConfig!.panelWidth),  Util.getMeasurementFeetToPixel(panelConfig!.panelLength));
      const panelMesh = new Mesh(panelGeom, new MeshStandardMaterial({transparent: true}));
      return {panelMesh, matrix};
    }

    createOrUpdateTemporaryPanel(roofPlane: Mesh, point: Vector3, disableSnap = false) {

        const roof = roofPlane?.parent;
        const instancedMesh = roof?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
        if(!instancedMesh)
            return;
        const {panelMesh, matrix} = this.getPanelMesh(instancedMesh);
        panelMesh.geometry.applyMatrix4(matrix);
        this.removeTemporaryPanel();
        this.temporaryTransparentPanel = this.createSinglePanelMesh(panelMesh, roofPlane, point, disableSnap, instancedMesh);
        // Guidelines for single panel
        this.createOrUpdateSinglePanelGuideLines(this.temporaryTransparentPanel);

        // Start # To scale down temporary panel to fit in between closest panels.
        // Util.scaleDownBufferGeo(this.temporaryTransparentPanel, Util.TEMP_PANEL_SCALE);
        // # End

        this.temporaryTransparentPanel.name = meshTypeEnum.temporaryPanelMesh;
        this.temporaryTransparentPanel.userData.meshtype = meshTypeEnum.temporaryPanelMesh;
        this.temporaryTransparentPanel.material = (this.temporaryTransparentPanel.material as MeshStandardMaterial).clone();
        (this.temporaryTransparentPanel.material as MeshStandardMaterial).map = this.panelWhiteTexture.clone();
        delete this.temporaryTransparentPanel.userData.enactStoreId;
        instancedMesh.parent?.add(this.temporaryTransparentPanel);
        this.temporaryTransparentPanel.visible = true;
    }
    createOrUpdateSinglePanelGuideLines(panelMesh: Mesh) {
        this.guidesGroup.clear();
        const panelVertices = Util.getMeshVertices(panelMesh);
        [panelVertices[2], panelVertices[3]] = [panelVertices[3], panelVertices[2]];
        const edges = [
            panelVertices[1].clone().sub(panelVertices[0]).setZ(0),
            panelVertices[2].clone().sub(panelVertices[1]).setZ(0),
            panelVertices[3].clone().sub(panelVertices[2]).setZ(0),
            panelVertices[0].clone().sub(panelVertices[3]).setZ(0)
        ];
        edges.forEach((edge, index) => {
            edge.setZ(0);
            const vevrt = panelVertices[index].clone()
            vevrt.setZ(0);
            const line = Util.createGuideline(edge, vevrt, `singlePanel${index + 1}`, undefined, 1499);
            line.renderOrder = renderOrders.singlePanelGuide;
            this.guidesGroup.add(line);
        });
        if(!this.guidesGroup.parent){
            this.engServ.scene.add(this.guidesGroup);
        }
    }

    overlappingHiddenPanels(instancedMesh: InstancedMesh, matrix: Matrix4){

      const panelArrayId = instancedMesh.parent?.name;
      let panelConfig: PanelArray;
      this.store.select(fromPanelArraySelectors.selectPanelArraysByIds([panelArrayId!])).pipe(take(1)).subscribe(arrayy=>{
        if(arrayy.length<=0) return;
        panelConfig = arrayy[0]!;
      })

      const panelGeom = new PlaneGeometry( Util.getMeasurementFeetToPixel(panelConfig!.panelWidth),  Util.getMeasurementFeetToPixel(panelConfig!.panelLength));
      const newAddedPanel = panelGeom.clone().applyMatrix4(matrix);


      const instancesToDelete: number[] = [];
        for (let i = 0; i < instancedMesh.count; i++) {
          const visiblity = InstancedMeshUtil.getVisibilityAt(instancedMesh, i);
          if(!visiblity){
            const matrix = new Matrix4();
            instancedMesh.getMatrixAt(i, matrix);
            const tempPanelGeom = panelGeom.clone();
            tempPanelGeom.applyMatrix4(matrix);
            if(Util.singlePanelOverlappingPanels(newAddedPanel, tempPanelGeom)){
              instancesToDelete.push(i);
            }
          }


        }
        return instancesToDelete;

    }

    isPanelPlacementValid(panelMesh: Mesh, roofPlaneIntersection: Intersection) {
        const result = {
            collidingWithPanel: false,
            collidingWithKeepout: false,
            collidingKeepout: new Mesh(),
            collidingObstacleSetback: false,
            collidingWithRoof: false,
            collidingWithSetback: false,
        }
        if (panelMesh && panelMesh.visible) {
            let roof: Mesh;
            if (roofPlaneIntersection?.object?.name?.split('-').shift() === meshTypeEnum.panel) {
                roof = roofPlaneIntersection.object.parent?.parent?.parent as Mesh;
            } else {
                const roofPlane = roofPlaneIntersection.object;
                roof = roofPlane.parent as Mesh;
            }

            if (roof) {
                let storeRoof: RoofSection | undefined;
                this.store.select(fromRoofSectionSelectors.selectRoofById([roof.name]))
                    .pipe(take(1))
                    .subscribe((roofsection) => {
                        if (roofsection[0])
                            storeRoof = roofsection[0]!
                    });
                if (!storeRoof) return result;
                const allKeepoutPtsResult = this.getAllKeepOutPointsOnRoof(storeRoof, false);
                const allKeepoutSetbackPtsResult = this.getAllKeepOutPointsOnRoof(storeRoof, true);
                const allKeepoutSetbackPts = allKeepoutSetbackPtsResult.keepouts;
                const instancedMesh = roof.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
                
                const allPanelPoints = instancedMesh ? this.getAllPanelPoints(instancedMesh, false) : {};
                const allPanelPointsJoin: Vector3[][] = [];
                // const panelArrayList = roof?.children.filter((child) => child.name.startsWith(storeIdPrefix.panelArray + "-")) ?? [];
                // const panelMeshes = panelArrayList.flatMap((panelArray) => panelArray.children[0]?.children ?? []) as Mesh[];
                Object.values(allPanelPoints).forEach((pm, i) => {
                    allPanelPointsJoin.push(pm);
                })
                // check with other panels, if collide make red
                result.collidingWithPanel = this.checkPanelCollisionWithKeepout(panelMesh.geometry, allPanelPointsJoin);
                if (result.collidingWithPanel) {
                    return result; // Exit early if collision with panels is detected
                }
                result.collidingWithRoof = this.checkRoofonRoofCollision(panelMesh.geometry, allKeepoutPtsResult.overlappingRoofs);
                // check with roof edges, if collide make red
                if (result.collidingWithRoof) {
                    return result; 
                }
                this.store.select(fromEdgeSelectors.selectEdgesByIds(storeRoof.edgeIds))
                    .pipe(
                        take(1),
                        switchMap(storeEdges => {
                            const vertStoreIds = storeEdges
                                .filter(edge => edge && edge.association.length > 0)
                                .map(edge => edge?.startVertexId ?? '');
                            return this.store.select(fromVertexSelectors.selectVerticesByIds(vertStoreIds))
                                .pipe(
                                    take(1),
                                    map(vertices => ({ vertices }))
                                );
                        })
                    )
                    .subscribe(({ vertices }) => {
                        const roofPolygon = vertices.map(vertex => new Vector3(vertex.x, vertex.y, vertex.z));
                        const panelVertices = Util.getMeshVertices(panelMesh as any, true);
                        [panelVertices[2], panelVertices[3]] = [panelVertices[3], panelVertices[2]];

                        // if panel center is inside the roof and all vertices are inside,
                        // panel is fully contained — no collision.
                        const panelCenter = Util.getCenter(panelMesh, true);
                        const allInside = panelVertices.every(v => CollisionUtil.isPointInPolygon(roofPolygon, v));
                        if (allInside && CollisionUtil.isPointInPolygon(roofPolygon, panelCenter)) {
                            result.collidingWithRoof = false;
                            return;
                        }

                        // panel is partially or fully outside — compute overlap ratio and compare with threshold
                        const overlapRatio = this.computePanelRoofOverlapRatio(panelVertices, roofPolygon);
                        const minRequiredOverlap = 1 - this.roofOverhangAllowance;
                        result.collidingWithRoof = overlapRatio < minRequiredOverlap;
                    });
                    
              // check with obstacles, if collide make red/yellow
                for (const keepoutId in allKeepoutPtsResult.keepouts) {
                    // Skip adjacent/overlapping roof sections — handled by roof-edge tolerance and setback checks
                    if (storeRoof.overlappingRoofs?.includes(keepoutId)) continue;
                    const keepoutVertices = allKeepoutPtsResult.keepouts[keepoutId];
                    if (this.checkPanelCollisionWithKeepout(panelMesh.geometry, [keepoutVertices])) {
                        result.collidingWithKeepout = true;
                        result.collidingKeepout = this.engServ.scene.getObjectByName(keepoutId) as Mesh;
                        return result; 
                    }
                }

                // check with setback edges, if collide make ye
                for (const keepoutId in allKeepoutSetbackPts) {
                    // Skip adjacent/overlapping roof sections — handled by roof-edge tolerance and setback checks
                    if (storeRoof.overlappingRoofs?.includes(keepoutId)) continue;
                    const keepoutVertices = allKeepoutSetbackPts[keepoutId];
                    if (this.checkPanelCollisionWithKeepout(panelMesh.geometry, [keepoutVertices])) {
                        result.collidingObstacleSetback = true;
                        break;
                    }
                }
                // check with roof setback, if collide make yellow
                if (!result.collidingWithRoof && storeRoof.setback >= 0) {
                    const roofsetbackPts = roof.userData.roofsetbackPts; // Inner setback points
                    result.collidingWithSetback = Util.singlePanelEdgeDetection(panelMesh, roofsetbackPts);
                    
                    // Also check if any panel vertex is outside the inner setback polygon.
                    // singlePanelEdgeDetection only detects edge crossings. At adjoining corners
                    // where 2 setback edges meet, a panel can be entirely in the setback zone
                    // without any edges crossing the setback boundary.
                    if (!result.collidingWithSetback && roofsetbackPts && roofsetbackPts.length >= 3) {
                        const tempPanelVertices = Util.getMeshVertices(panelMesh as any, true);
                        for (let i = 0; i < tempPanelVertices.length; i++) {
                            if (!CollisionUtil.isPointInPolygon(roofsetbackPts, tempPanelVertices[i])) {
                                result.collidingWithSetback = true;
                                break;
                            }
                        }
                    }
                }
            }
        }
        return result;
        //   return false;
    }

    rotatePanelAlongCenter(mesh: Mesh, rotateFinal: boolean = false) {
        const roof = mesh.parent?.parent?.parent;
        if (!roof) return;
        const roofNormal = (roof.userData as MeshUserData).roofNormal ? new Vector3().copy((roof.userData as MeshUserData).roofNormal as Vector3) : undefined;
        if (!roofNormal) return;
        const centerForRotationLocal = new Vector3();
        const points = Util.getPointsFromGeometery(mesh.geometry);
        const bbox = new Box3().setFromPoints(points);
        bbox.getCenter(centerForRotationLocal);
        //translate to the original position
        mesh.geometry.translate(-centerForRotationLocal.x, -centerForRotationLocal.y, -centerForRotationLocal.z);
        //rotate
        this.flattenRotateFlush(mesh, roofNormal);
        //translate back to the applied position
        mesh.geometry.translate(centerForRotationLocal.x, centerForRotationLocal.y, centerForRotationLocal.z);
        mesh.updateMatrix();
    }

    checkForErorrs(roof: Mesh){

        if (!roof) {
            const message = this.translateMsg('roofNtFound');
            console.warn(message);
            return undefined;
        }
        const instancedMesh = roof.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
        if (!instancedMesh) {
            const message = this.translateMsg('roofHsntPanels');
            console.warn(message);
            return undefined;
        }



        let storePanelArray: PanelArray;
        this.store.select(fromPanelArraySelectors.selectPanelArraysByRoofId(roof.name)).pipe(take(1)).subscribe(panelArrs=>{
          if(panelArrs.length<=0) return;
          storePanelArray = panelArrs[0];
        })

        if (storePanelArray!.arrayType == '2') { //TODO: replace with east west
            this.notificationService.sendMessage({
                message: this.translateMsg('singlePanelEWError'),
                type: NotificationType.warning,
                positionClass: "toast-bottom-left",
                timeOut: 5000
            });
            const message = this.translateMsg('pnlPlcmntNotAlwd');
            console.warn(message);
            return undefined;
        }

        if(instancedMesh.count == (instancedMesh.userData as MeshUserData).maxInstanceCount){
            this.notificationService.sendMessage({
                message: this.translateMsg('maxNoOfPanels', true),
                type: NotificationType.warning,
                positionClass: "toast-bottom-left",
                timeOut: 5000
            });
            console.warn("Max No Of Panels added");
            return undefined;
        }
        return true;
    }

    createSinglePanelMesh(closestPanelMesh: Mesh, roofPlane: Mesh, interSectPoint: Vector3, disableSnap = false, instancedMesh?: InstancedMesh) {
        const mesh = closestPanelMesh.clone();
        mesh.geometry = closestPanelMesh.geometry.clone();
        const meshNormal = Util.getMeshNormal(mesh);
        if(meshNormal.z < 0){
            meshNormal.negate();
        }
        const roofNormal = Util.getMeshNormal(roofPlane);
        if(roofNormal.z < 0){
            roofNormal.negate();
        }
        mesh.updateMatrix();
        const point = Util.getMeshVertices(mesh)[3];
        const quaternionNeg = new Quaternion().setFromUnitVectors(meshNormal, roofNormal);
        mesh.geometry.translate(-point.x, -point.y, -point.z);
        mesh.geometry.applyQuaternion(quaternionNeg);
        mesh.geometry.translate(point.x, point.y, point.z);
        // Rotation and flush to roof
        if (this.isSinglePanelRotated) {
            this.singlePanelRotationAndFlush(mesh, roofNormal);
        }
        const translateVector =  new Vector3().copy(interSectPoint).sub(Util.getCenter(mesh, true));
        mesh.geometry.translate(translateVector.x, translateVector.y, 0);
        
        const pointTwo = Util.getMeshVertices(mesh, true)[this.isSinglePanelRotated ? 0 :3]; //after rotation the bottom vertex is different
        mesh.geometry.translate(-pointTwo.x, -pointTwo.y, -pointTwo.z);
        mesh.geometry.applyQuaternion(quaternionNeg.invert());
        mesh.geometry.translate(pointTwo.x, pointTwo.y, pointTwo.z);
        mesh.updateMatrix();
        mesh.updateMatrixWorld();
        let isSnap = false;
        if(!disableSnap){
            isSnap = this.snapToClosestPanel(roofPlane, mesh, instancedMesh);
        }
        mesh.updateMatrix();
        mesh.updateMatrixWorld();
        const centerPrev = Util.getCenter(closestPanelMesh, true);
        const centerNow = Util.getCenter(mesh, true);

        const translate = new Vector3().copy(centerNow).sub(centerPrev);
        if(!isSnap){
            const h = -(translate.x*roofNormal.x + translate.y*roofNormal.y)/roofNormal.z-translate.z;
            translate.z = translate.z+h;
            mesh.position.setZ(translate.z);
        }
        const matrix = new Matrix4().makeTranslation(translate);
        mesh.translateZ(constants.SinglePanelOffzetZ);        
        mesh.updateMatrix();
        mesh.updateMatrixWorld();
        mesh.userData.matrix = matrix;

        return mesh;
    }

    toggleSinglePanelOrientation(){
        this.isSinglePanelRotated = !this.isSinglePanelRotated;
    }

    addSinglePanel(intersects: Intersection[]) {
        // intersects = intersects.filter(int => (int.object.name != meshTypeEnum.temporaryPanelMesh && !int.object.name.includes(meshTypeEnum.panel)))

        if (this.invalidSinglePanel || this.cursorState != PanelArrayCursors.VALIDSINGLEPANELADD) {
            const message = this.translateMsg('invalidPlacemntForSnglePanel');
            console.warn(message);
            return undefined;
        }
        
        const roofPlane = (intersects.find(i=> i.object.name.includes(meshTypeEnum.roofPlane))?.object
            ?? this.lastSinglePanelRoofPlane) as Mesh;
        if (!roofPlane?.parent) {
            console.warn('No roof plane found for single panel placement');
            return undefined;
        }
        const roof = roofPlane.parent as Mesh;

        if(!this.checkForErorrs(roof)){
            return undefined;
        }

        if(!this.temporaryTransparentPanel) return;

        const panelInstancedMesh = roof.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
        if(!panelInstancedMesh) return;

        const panelArrayId = panelInstancedMesh.parent!.name;
        let storePanelArray: PanelArray | undefined;
        this.store.select(fromPanelArraySelectors.selectPanelArraysByIds([panelArrayId])).pipe(take(1)).subscribe((panelArrays)=>{
          if(!panelArrays || panelArrays.length<=0)return;
          storePanelArray = panelArrays[0];
        })
        if(!storePanelArray) return undefined;

        const {panelMesh, matrix} = this.getPanelMesh(panelInstancedMesh);
        const matrix1 = this.temporaryTransparentPanel.userData.matrix;
        if(this.isSinglePanelRotated){
          panelMesh.rotateOnAxis(new Vector3(0,0,1), Math.PI / 2);
        }
        panelMesh.applyMatrix4(matrix);
        panelMesh.applyMatrix4(matrix1);
        
        panelMesh.updateMatrix();
        panelMesh.updateMatrixWorld();

        const instancesToDelete = this.overlappingHiddenPanels(panelInstancedMesh,panelMesh.matrix);
            this.store.select(fromPanelSelectors.selectPanelsByInstanceIds(instancesToDelete, storePanelArray.roofId)).pipe(take(1)).subscribe((panels)=>{
              this.DeletePanels(panels.map(p=> p.id), storePanelArray!.roofId);
        })

        InstancedMeshUtil.addInstance(panelInstancedMesh, panelMesh.matrix);
        let maxPillarId;
        this.store.select(fromFrameSelectors.selectFrameWithMaxPillarId(storePanelArray.frameIds)).pipe(take(1)).subscribe((val) => {
            maxPillarId = val;
        });
        if(maxPillarId == undefined || maxPillarId == -1) return undefined;

        this.structureGeometryService.addSinglePanelPillarInstance(roof, panelMesh, storePanelArray, maxPillarId);

        this.removeTemporaryPanel();
        this.guidesGroup.clear();

        const tempPanelObj = {
          name: Util.generateStoreId(storeIdPrefix.singlePanel),
          orientation:this.isSinglePanelRotated? PanelOrientation.landscape : PanelOrientation.portrait,
          instanceId: panelInstancedMesh.count-1
        }
        this.storeUtil.storeSinglePanel(tempPanelObj, panelArrayId, maxPillarId);
        // let storePanels = JSON.parse(JSON.stringify(storePanelArray));
        // // Deleting overlapped hidden panels (By Obstacles or Walkways)
        this.store.dispatch(fromAdditionalToolsActions.SetContinousPanelCount({continousPanelCount: this.continousPanelCount + 1}));
        
        // visibility is sync after single panel addition
        if (storePanelArray) {
            this.syncStoreVisibilityWithSceneAsync(panelInstancedMesh, storePanelArray)
                .catch(error => console.error('Error syncing visibility after single panel addition:', error));
        }
        
        this.store.dispatch(fromUndoRedoActions.TriggerURSnapshot({action: fromPanelArrayActions.UpsertOne, notification: this.translateMsg('design.undoRedo.singlePanelAdd',false)}))
        return panelInstancedMesh;
    }


    flattenRotateFlush(mesh: Mesh, roofNormal: Vector3) {
        //Flat as per ground
        const quaternionNeg = new Quaternion().setFromUnitVectors(roofNormal, new Vector3(0, 0, 1));
        mesh.geometry.applyMatrix4(new Matrix4().makeRotationFromQuaternion(quaternionNeg));
        //Rotate 90 degrees
        const qrot = new Quaternion().setFromAxisAngle(new Vector3(0, 0, 1), Math.PI / 2);
        mesh.geometry.applyQuaternion(qrot);
        //Flush on roof
        const quaternion = new Quaternion().setFromUnitVectors(new Vector3(0, 0, 1), roofNormal);
        mesh.geometry.applyMatrix4(new Matrix4().makeRotationFromQuaternion(quaternion));
    }

    singlePanelRotationAndFlush(mesh: Mesh, roofNormal: Vector3) {
        const centerForRotationLocal = Util.getCenter(mesh, true);
        //translate to the original position
        mesh.geometry.translate(-centerForRotationLocal.x, -centerForRotationLocal.y, -centerForRotationLocal.z);
        if(this.isSinglePanelRotated){
            this.flattenRotateFlush(mesh, roofNormal);
        }
        //translate to the applied position
        mesh.geometry.translate(centerForRotationLocal.x, centerForRotationLocal.y, centerForRotationLocal.z);
        mesh.updateMatrix();
    }

    drawNewSinglePanelMesh(newMeshVertices: Vector3[]): Mesh {
        const mesh = Util.drawPolygon(newMeshVertices, meshTypeEnum.panelMesh);
        mesh.translateZ(0.1); // move panels by 0.1 units to disable flickering;
        mesh.material = new MeshStandardMaterial({
            map: this.panelTexture.clone(),
            side: DoubleSide,
            // color: threeColors.panelColor,
            transparent: true,
        });
        mesh.geometry.computeVertexNormals();
        mesh.renderOrder = 1;
        mesh.castShadow = true;
        mesh.receiveShadow = true;
        return mesh;
    }


    rotateSinglePanel(panelId: string, orientation: PanelOrientation) {
        const panelMesh = this.engServ.scene.getObjectByName(panelId) as Mesh | undefined;
        if (!panelMesh) {
            console.error(`PanelGeometry.rotateSinglePanel: Panel ID ${panelId} not found in Scene.`);
            return;
        }
        const rotatePanelInStoreSubscription = this.store.select(fromPanelSelectors.selectPanelsByIds([ panelId ]))
            .pipe(take(1))
            .subscribe((panels) => {
                try {
                    const panel = panels[0];
                    if (!panel) {
                        throw new Error(`Panel ID ${panelId} not found in Store.`);
                    }
                    if (panel.orientation !== orientation) {
                        this.rotatePanelAlongCenter(panelMesh);
                        this.store.dispatch(fromPanelActions.UpsertOne({ panel: {
                            ...panel,
                            orientation: orientation,
                        } }));
                    }
                } catch (err: any) {
                    console.error('PanelGeometry.rotateSinglePanel: ' + err.message);
                } finally {
                    // rotatePanelInStoreSubscription.unsubscribe();
                }
            });
    }

    DeleteInstances(panelIds: string[], storePanelArr: PanelArray){
      const instancedMesh = this.engServ.scene
        .getObjectByName(storePanelArr.id)
        ?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
      if (
        (instancedMesh.userData as MeshUserData).meshtype !=
        meshTypeEnum.instancedMesh
      )
        return;
      let panelsToBeDeleted: Panel[] | undefined;
      this.store
        .select(fromPanelSelectors.selectPanelsByIds(panelIds))
        .pipe(take(1))
        .subscribe((panels) => {
          if (panels && panels.length <= 0) return;
          panelsToBeDeleted = JSON.parse(JSON.stringify(panels));
        });
      if (!panelsToBeDeleted) return;
      const instanceIdToPanelId : {[key:number]: string}= {};
      const panelIdToInstance : {[key:string]: number}= {};

      panelsToBeDeleted.forEach((panel) =>{
        if(panel){
          instanceIdToPanelId[panel.instanceId] = panel.id;
          panelIdToInstance[panel.id] = panel.instanceId;
        }
      })
      const panelsToBeUpdatedInStore: {[key: number]:Panel} = {};
      panelIds.forEach((id) => {
        const instanceId = panelIdToInstance[id];
        InstancedMeshUtil.delete(instancedMesh, instanceId); //When we delete an instance the last instance instance id changes
        const lastInstanceId = instancedMesh.count;
        const lastIndexPanelId = instanceIdToPanelId[lastInstanceId];

        if (lastIndexPanelId) {
          delete panelIdToInstance[id];
          delete instanceIdToPanelId[lastInstanceId];
          if(lastIndexPanelId != id){
            panelIdToInstance[lastIndexPanelId] = instanceId;
            instanceIdToPanelId[instanceId] = lastIndexPanelId;
          }

        } else {
          if(panelsToBeUpdatedInStore[lastInstanceId]){
            panelsToBeUpdatedInStore[lastInstanceId].instanceId = instanceId;
            panelsToBeUpdatedInStore[instanceId] = panelsToBeUpdatedInStore[lastInstanceId];
            delete panelsToBeUpdatedInStore[lastInstanceId];
          }else{
            this.store
            .select(
              fromPanelSelectors.selectPanelsByInstanceIds(
                [lastInstanceId],
                storePanelArr.roofId
              )
            )
            .pipe(take(1))
            .subscribe((panels2) => {
              if (panels2.length <= 0) return;
              const lastPanel = JSON.parse(JSON.stringify(panels2[0]));
              lastPanel.instanceId = instanceId;
              panelsToBeUpdatedInStore[instanceId] = lastPanel;
            });

          }
          delete panelIdToInstance[id];
          delete instanceIdToPanelId[instanceId];

        }
      });
      this.store.dispatch(
        fromPanelActions.UpsertMany({ panels: Object.values(panelsToBeUpdatedInStore)})
      );

    }

    updateFrames(storeFrames: (Frame | undefined)[], currentPanelsToDelete: string[]) {
        const framesToDelete: Array<Frame> = [];
        const frameIdsToDelete: Array<Frame['id']> = [];
        const framesToUpdate: Array<Frame> = [];
        const newFrames = JSON.parse(JSON.stringify(storeFrames));
    
        newFrames.forEach((newFrame: Frame) => {
            if(newFrame) {
                const originalPanelCountInFrame = newFrame.panelIds.length;
                newFrame.panelIds = newFrame.panelIds.filter((id: string) => !currentPanelsToDelete.includes(id));
        
                if (newFrame.panelIds.length === 0) {
                    framesToDelete.push(newFrame);
                    frameIdsToDelete.push(newFrame.id);
                } else if(newFrame.panelIds.length !== originalPanelCountInFrame) {
                    framesToUpdate.push(newFrame);
                }
            }
        });
    
        return { framesToDelete,frameIdsToDelete, framesToUpdate };
    }

    updatePanels(storePanelArr: PanelArray, panelData: ( Panel | undefined)[], frameIdsToDelete: Array<Frame['id']>) {
        const newPanelArray: PanelArray = JSON.parse(JSON.stringify(storePanelArr));
        let noOfPanelEast = 0;
        let noOfPanelWest = 0;
        const isEastWest = newPanelArray.arrayType === '2';
    
        panelData.forEach((panel: Panel | undefined) => {
            const indexToRemove = newPanelArray.panelIds.indexOf(panel!.id);
            if (indexToRemove !== -1) {
                newPanelArray.panelIds.splice(indexToRemove, 1);
                if(panel!.visible){
                    if (isEastWest && panel?.azimuth === newPanelArray.azimuth2) {
                        noOfPanelWest--;
                    } else {
                        noOfPanelEast--;
                    }
                }                
            }
        });    
        if(frameIdsToDelete.length) {
            newPanelArray.frameIds = newPanelArray.frameIds.filter(id => !frameIdsToDelete.includes(id));
        }
        newPanelArray.totalAddedPanels = newPanelArray.panelIds.length;
        newPanelArray.numberOfPanels += noOfPanelEast + noOfPanelWest;
        newPanelArray.noOfPanelEast += noOfPanelEast;
        newPanelArray.noOfPanelWest = (newPanelArray.noOfPanelWest || 0) + noOfPanelWest;
        newPanelArray.totalWatts = newPanelArray.numberOfPanels * newPanelArray.wattsPerModule;
    
        return { newPanelArray };
    }

    dispatchActions(framesToDelete: Array<Frame['id']>, framesToUpdate: Array<Frame>, currentPanelsToDelete: string[], newPanelArray: PanelArray) {
        // Execute batch operations
        if (framesToDelete.length) {
            this.store.dispatch(fromFrameActions.DeleteMany({ frameIds: framesToDelete }));
        }
        if (framesToUpdate.length) {
            this.store.dispatch(fromFrameActions.UpsertMany({ frames: framesToUpdate }));
        }
    
        this.store.dispatch(fromPanelActions.DeleteMany({ panelIds: currentPanelsToDelete }));
    
        if (newPanelArray.panelIds.length === 0) {
            this.store.dispatch(fromPanelArrayActions.PanelArrayDelete({ panelArray: newPanelArray }));
        } else {
            this.store.dispatch(fromPanelArrayActions.UpsertOne({ panelArray: newPanelArray }));
        }

        // validate and fix any visibility sync issues after panel deletion
        this.validateAndFixVisibilitySyncAsync()
            .catch(error => console.error('Error syncing visibility after panel deletion:', error));
    }

    DeletePanels(panelIds: string[], roofId?: string) {
        // Fetch all necessary data in a batch
        if(!panelIds.length) return;
        let selector: any = '';

        if(roofId) {
            selector = fromPanelArraySelectors.selectPanelArraysByRoofId(roofId);
        } else {
            selector = fromPanelArraySelectors.allPanelArrays;
        }

        this.store.select(selector).pipe(take(1))
            .subscribe(storePanelArrays => {
    
                storePanelArrays.forEach((storePanelArr: PanelArray) => {
                    const currentPanelsToDelete = panelIds.filter(id => storePanelArr.panelIds.includes(id));
                    if (currentPanelsToDelete.length === 0) return;

                    this.DeleteInstances(currentPanelsToDelete, storePanelArr);
                    if (currentPanelsToDelete.length == storePanelArr.panelIds.length) {
                        const storePanelArrToBeRemoved = this.engServ.scene.getObjectByName(storePanelArr.id);
                        Util.removeObjWithChildren(storePanelArrToBeRemoved);
                    }

                    forkJoin([
                        this.store.select(fromFrameSelectors.selectFramesByIds(storePanelArr.frameIds))
                        .pipe(take(1)),
                        this.store.select(fromPanelSelectors.selectPanelsByIds(currentPanelsToDelete))
                        .pipe(take(1)),
                        this.store.select(fromPanelSelectors.getPanelsByAssociation(storePanelArr.roofId))
                        .pipe(take(1))
                    ]).subscribe(([storeFrames, panelData, associatedPanels]) => {

                        const remainingVisiblePanels = associatedPanels.filter((p: any) => p && p.visible && !currentPanelsToDelete.includes(p.id)).length;

                        if (!remainingVisiblePanels) {
                            this.engServ.scene.getObjectByName(storePanelArr.id)?.removeFromParent();
                            this.store.dispatch(fromPanelActions.DeleteMany({ panelIds: storePanelArr.panelIds }));
                            this.store.dispatch(fromFrameActions.DeleteMany({ frameIds: storePanelArr.frameIds }));
                            this.store.dispatch(fromPanelArrayActions.PanelArrayDelete({ panelArray: storePanelArr }));
                            this.store.dispatch(fromUiActions.ClearSelection());
                            return;
                        }

                        let { framesToDelete, frameIdsToDelete,framesToUpdate } = this.updateFrames(storeFrames, currentPanelsToDelete);
                        const panelInstanceMesh = this.engServ.scene
                            .getObjectByName(storePanelArr.id)
                            ?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
                        const pillarInstanceMesh = this.engServ.scene
                            .getObjectByName(storePanelArr.id)
                            ?.getObjectByName(meshTypeEnum.pillerArray) as InstancedMesh;
                        if (pillarInstanceMesh)
                        {
                        framesToUpdate = this.structureGeometryService.updatePillarsVisibility(pillarInstanceMesh, panelInstanceMesh, framesToUpdate);
                        this.structureGeometryService.updatePillarsVisibility(pillarInstanceMesh, panelInstanceMesh, framesToDelete, true);
                        }

                        const { newPanelArray } = this.updatePanels(storePanelArr, panelData, frameIdsToDelete);
                    
                        this.dispatchActions(frameIdsToDelete, framesToUpdate, currentPanelsToDelete, newPanelArray);
                    });
                });
            });
    }


    calculatePanelBySelection(selectedRoof: Object3D, panelConfig?: PanelArray): any {
        try {
            if (!panelConfig) {
                this.updateModule();
                panelConfig = Object.assign({},this.defaultPanelConfigObj);
            }
            if (this.drawActive) {
                panelConfig.isDrawToFill = true;
            }
            const roofId = selectedRoof.name;
            const isExisting = panelConfig.id != "";
            const isEastWest = panelConfig.arrayType == '2';
            if (!isExisting) {
                panelConfig.id = Util.generateStoreId(storeIdPrefix.panelArray);
                panelConfig.roofId = roofId;
                panelConfig.orientation = isEastWest ? PanelOrientation.landscape : PanelOrientation.portrait;
            }
            const existingpanelGroup = this.engServ.scene.getObjectByName(panelConfig.id);
            if (existingpanelGroup) {
                this.panelGroupObj = existingpanelGroup;
            }
            else {
                this.panelGroupObj.name = panelConfig.id;
                this.panelGroupObj.userData = new MeshUserData(panelConfig.id, meshTypeEnum.panelGroup);
            }

            // NOTE: In case of scene restoration, if the userData of a roof Object isn't instantiated, then creating new Vector3 acts as a fallback.
            const roofNormal = new Vector3().copy((selectedRoof.userData as MeshUserData).roofNormal as Vector3);
            if (roofNormal && roofNormal.z < 0.0) {
                roofNormal.negate()
            }
            const storeRoof = this.GetStoreRoofSection(roofId);

            if (!storeRoof || !roofNormal) {
                throw new Error("Unable to find Roof in store")
            }
            const isFlatRoof = storeRoof.pitch <= flatRoofDefaults.pitch;
            const roofPlane = selectedRoof.getObjectByName(meshTypeEnum.roofPlane) as Mesh;
            const roofPoints = this.GetVertsFromMesh(roofPlane);
            const roofConfirmedPlane = Util.getPlaneFromMesh(roofPlane);
            panelConfig.roofTilt = storeRoof.pitch;
            const azimInitial = this.getInitialAzim(panelConfig);
            const frameHeightTall = panelConfig.frameHeight + panelConfig.panelLength*panelConfig.noOfRows*Math.sin(Util.convertDegreeToRadian(panelConfig.panelTilt));

            {
                if (!isExisting) {
                    if (isFlatRoof) {
                        if(panelConfig.arrayType == '0'){
                            panelConfig.arrayTypeName = 'Fixed (Open Rack)';
                            panelConfig.arrayType = '1';
                        }
                        panelConfig.panelTilt = flatRoofDefaults.panelTilt;
                    } else {
                        panelConfig.panelTilt = 0;
                    }
                    panelConfig.azimuth = azimInitial;
                    panelConfig.interrowspacing = this.calculateInterRowSpacing(panelConfig, storeRoof.pitch);
                    panelConfig.defaultInterrowspacing = panelConfig.interrowspacing;

                    // Fetching user preferences for panel tilt and inter-row spacing
                    // This is only done for new panels, not for existing ones
                    this.store.select(fromMetaDataSelectors.selectPreference)
                        .pipe(take(1))
                        .subscribe((obj: any) => {
                            const preferencesObj = obj?.preferencesObj;
                            if (!preferencesObj || !panelConfig) return;
                            const panelTiltValue = preferencesObj?.system_design?.panel_tilt?.value;
                            if (panelTiltValue !== undefined && panelTiltValue !== null
                                && typeof panelTiltValue === 'number' && panelTiltValue >= 0 && panelTiltValue <= 90) {
                                panelConfig.panelTilt = panelTiltValue;
                            }
                            const interRowSpaceValue = preferencesObj?.system_design?.inter_row_space?.value;
                            if (interRowSpaceValue !== undefined && interRowSpaceValue !== null
                                && typeof interRowSpaceValue === 'number' && interRowSpaceValue >= 0) {
                                panelConfig.interrowspacing = interRowSpaceValue;
                            }

                            // Set panel degradation from preferences
                            if (
                                preferencesObj?.system_design?.panel_degradation !== undefined &&
                                preferencesObj?.system_design?.panel_degradation?.visible &&
                                preferencesObj?.system_design?.panel_degradation != null
                            ) {
                                const degradationValue = preferencesObj.system_design.panel_degradation.value;
                                if (typeof degradationValue === 'number' && degradationValue >= 0 && degradationValue <= 100) {
                                    panelConfig.degradation = degradationValue;
                                }
                            }

                            // Set panel orientation from preferences overwrite panel config default if preference exists
                            const panelOrientationValue = preferencesObj?.system_design?.panel_orientation?.value;
                            if (panelOrientationValue !== undefined && panelOrientationValue !== null
                                && Object.values(PanelOrientation).includes(panelOrientationValue)) {
                                panelConfig.orientation = panelOrientationValue;
                            }

                            // Set panel alignment from preferences overwrite panel config default if preference exists
                            const panelAlignmentValue = preferencesObj?.system_design?.panel_alignment?.value;
                            if (panelAlignmentValue !== undefined && panelAlignmentValue !== null
                                && Object.values(ArrayAlignment).includes(panelAlignmentValue)) {
                                panelConfig.alignment = panelAlignmentValue;
                            }

                            // Recalculate interrowspacing using the final orientation and tilt values (which
                            // may have been overridden by preferences above). This prevents landscape arrays
                            // being created with portrait-based interrowspacing when the user preference is landscape.
                            if ((interRowSpaceValue === undefined || interRowSpaceValue === null) && !isEastWest) {
                                panelConfig.interrowspacing = this.calculateInterRowSpacing(panelConfig, storeRoof.pitch);
                                panelConfig.defaultInterrowspacing = panelConfig.interrowspacing;
                            }
                        });
                }

                const maxAllowedTilt = 90 - storeRoof.pitch;
                if (panelConfig.panelTilt >= maxAllowedTilt) {
                    // Panel cannnot be tilted more than 90 degree - including roof tilt
                    const message = `panel tilt cannot be more than ${maxAllowedTilt} for current roof`;
                    console.warn(message);
                    panelConfig.panelTilt = maxAllowedTilt;
                }
                panelConfig.showEdgeSetback = storeRoof.setbackVisible;
                panelConfig.frameHeightTall = frameHeightTall;

            }
            const panelStoreData: PanelStoreData = {
                storeMetadata: panelConfig,
                roofPitch: storeRoof.pitch,
                alignment: panelConfig.alignment ?? ArrayAlignment.justify,
            }

            let polygonPoints = roofPoints;
            if (this.drawActive) {
                // if draw to fill, then use the points from the draw polygon
                polygonPoints = this.drawVertexList.map(m => m.position);
                // panelArraySetback = 0;
            } else if (panelConfig.isDrawToFill) {
                const panelArray = this.engServ.scene.getObjectByName(panelConfig.id);
                const drawMesh = panelArray?.getObjectByName(meshTypeEnum.drawPanelShape) as Mesh;
                if (drawMesh) {
                    polygonPoints = this.GetVertsFromMesh(drawMesh, false);
                }
            }
            const [edgeLeft, edgeRight] = isEastWest && isFlatRoof ? this.storeUtil.GetRoofRidgeVertices(storeRoof) : this.storeUtil.GetRoofGutterVertices(storeRoof);
            if (!edgeLeft || !edgeRight) {
                throw new Error("Unable to find gutter and ridge");
            }
            const edgeVector = new Vector3().subVectors(edgeRight, edgeLeft).normalize();
            this.debugUtil.DebugPanelGutterDir(this.panelGroupObj, edgeVector, edgeLeft);

            if (panelConfig.azimuth != azimInitial) {
                const azimuthChange = panelConfig.azimuth - azimInitial;
                const angleRad = MathUtils.degToRad(azimuthChange);
                edgeVector.applyAxisAngle(new Vector3(0, 0, -1), angleRad);
            }


            let { globalProjectedPanelFrameCorners: validProjectedPanelFrameCorner3D, globalToLocal, allKeepOutPointsOnRoof } = this.getValidPanelFrameCorners(polygonPoints, roofPoints, edgeLeft, edgeVector, roofNormal, edgeRight, storeRoof, panelConfig);
            if (this.checkIfDrawPanelsInSelectedArea(roofId, globalToLocal, polygonPoints, panelConfig.id)) {
                throw Error("Panel Already Exists");
            }

            if (validProjectedPanelFrameCorner3D.length <= 0) {
                if (!isExisting && !isEastWest) {
                    panelConfig.orientation = PanelOrientation.landscape;
                    // Recalculate interrowspacing for the switched landscape orientation when no
                    // explicit user preference for inter_row_space was set. Portrait interrowspacing
                    // uses panelLength (larger) while landscape uses panelWidth (shorter), so keeping
                    // the portrait value leads to over-spaced rows in the landscape array.
                    if (panelConfig.interrowspacing === panelConfig.defaultInterrowspacing) {
                        panelConfig.interrowspacing = this.calculateInterRowSpacing(panelConfig, storeRoof.pitch);
                        panelConfig.defaultInterrowspacing = panelConfig.interrowspacing;
                    }
                    ({ globalProjectedPanelFrameCorners: validProjectedPanelFrameCorner3D, globalToLocal, allKeepOutPointsOnRoof } = this.getValidPanelFrameCorners(polygonPoints, roofPoints, edgeLeft, edgeVector, roofNormal, edgeRight, storeRoof, panelConfig));
                    if (this.checkIfDrawPanelsInSelectedArea(roofId, globalToLocal, polygonPoints, panelConfig.id)) {
                        throw Error("Panel Already Exists");
                    }
                    if (validProjectedPanelFrameCorner3D.length <= 0) {
                        this.notificationService.sendMessage({
                            message: this.translateMsg('UnableToFit'),
                            type: NotificationType.danger,
                            positionClass: "toast-bottom-left",
                            timeOut: 5000
                        });
                        throw new Error(this.translateMsg('UnableToFit'));
                    }
                } else {
                    this.notificationService.sendMessage({
                        message: this.translateMsg('UnableToFit'),
                        type: NotificationType.danger,
                        positionClass: "toast-bottom-left",
                        timeOut: 5000
                    });
                    throw new Error(this.translateMsg('UnableToFit'));
                }
            }
            const roofArea = Util.calculateArea(roofPlane);
            let { panelsUserdataArray, frames, panelInstanceMesh , pillarInstanceMesh} = this.createPanelMeshes(validProjectedPanelFrameCorner3D, panelConfig, edgeVector, roofConfirmedPlane, roofArea, roofPoints);
            const keepOutPointsArray = Object.values(allKeepOutPointsOnRoof.keepouts);
            const invisibleIndices = this.invisiblePanelsOverlappingWithObstacles(panelConfig, panelInstanceMesh, keepOutPointsArray, allKeepOutPointsOnRoof.overlappingRoofs);
            if(pillarInstanceMesh)
                {   
                    const toBeUpdatedFrameIds = new Set<string>();
                    invisibleIndices.forEach((index) => {
                        const panel = panelsUserdataArray[index];
                        if (panel && panel.frameId) {
                            toBeUpdatedFrameIds.add(panel.frameId);
                        }
                    });
                    const toBeUpdatedFrames : Frame[]= [];
                    frames.forEach(f => {
                        if(toBeUpdatedFrameIds.has(f.id)){
                            f.isDefaultStructure = false;
                            toBeUpdatedFrames.push(f)
                        }
                    });
                    this.structureGeometryService.updatePillarsVisibility(pillarInstanceMesh,panelInstanceMesh, toBeUpdatedFrames);
                }
            let eastWestCount;
            ({ eastWestCount, panelsUserdataArray } = this.createRawPanelsData(invisibleIndices, panelsUserdataArray, isEastWest, panelConfig));
            const noOfVisiblePanels = panelsUserdataArray.filter(p=>p.visible).length;
            if(noOfVisiblePanels === 0){
                this.notificationService.sendMessage({
                    message: this.translateMsg('UnableToFit'),
                    type: NotificationType.danger,
                    positionClass: "toast-bottom-left",
                    timeOut: 5000
                });
                throw new Error(this.translateMsg('UnableToFit'));
            }

            this.panelGroupObj.add(panelInstanceMesh);
            if(pillarInstanceMesh)
                this.panelGroupObj.add(pillarInstanceMesh);
            this.panelGroupObj.position.z = (Util.DEFAULT_PANEL_ARRAY_MARGIN + Util.getMeasurementFeetToPixel(panelConfig.frameHeight));
            this.panelGroupObj.updateMatrix();
            this.panelGroupObj.updateMatrixWorld();
            selectedRoof.add(this.panelGroupObj);

            const { shapeVertexIds, shapeEdgeIds } = this.getPanelArrayShape(storeRoof, isExisting, panelConfig, roofId);
            return { shapeVertexIds, shapeEdgeIds, panelsUserdataArray, panelStoreData, frames, isExisting, eastWestCount };
        } catch (error: any) {
            if (this.drawActive) {
                this.terminatePanelDraw();
            }
            const message = `${this.translateMsg('addPnlsErr')} ` + (error.message ?? "");
            console.warn(message);
            //console.error('AddPanels Error: ' + error.stack);
            return {shapeVertexIds: null, shapeEdgeIds: null, panelsUserdataArray: null, panelStoreData: null, frames: null, isExisting: null, eastWestCount: null};
        }
    }

    private createRawPanelsData(invisibleIndices: number[], panelsUserdataArray: MeshUserData[], isEastWest: boolean, panelConfig: PanelArray | undefined) {
        const invisibleIndicesSet = new Set(invisibleIndices);
        const modifiedPanelsData: Panel[] = [];
        const eastWestCount = {
            noOfPanelEast: 0,
            noOfPanelWest: 0
        };
        panelsUserdataArray.forEach((p, i) => {
            if (p.instanceId == undefined) return;
            if (invisibleIndicesSet.has(i)) {
                p.visible = false;
            } else {
                p.visible = true;
            }
            if (isEastWest && p?.azimuth == panelConfig?.azimuth2) {
                if (p.visible) eastWestCount.noOfPanelWest++;
            } else {
                if (p.visible) eastWestCount.noOfPanelEast++;
            }
            const modifiedPanel: Panel = {
                id: p.enactStoreId!,
                visible: p.visible,
                instanceId: p.instanceId,
                configurationId: ConfigurationIds.SinglePanel,
                orientation: p.orientation ?? PanelOrientation.portrait,
                association: panelConfig?.roofId ?? '',
                frameId: p.frameId!,
                azimuth: p.azimuth!
            };
            modifiedPanelsData.push(modifiedPanel);
        });
        panelsUserdataArray = modifiedPanelsData as any[];
        return { eastWestCount, panelsUserdataArray };
    }

    private getPanelArrayShape(storeRoof: RoofSection, isExisting: boolean, panelConfig: PanelArray, roofId: string) {
        let shapeVertexIds = storeRoof.vertexIds;
        let shapeEdgeIds = storeRoof.edgeIds;

        if (isExisting) {
            shapeVertexIds = panelConfig.vertices ?? [];
            shapeEdgeIds = panelConfig.edges ?? [];
        } else if (this.drawActive) {
            const [boundaryVertices, boundaryEdges] = this.storeUtil.storeDrawPanelShape(this.drawVertexList, this.drawEdgeList, roofId);
            shapeVertexIds = (boundaryVertices as Vertex[]).map(v => v.id);
            shapeEdgeIds = (boundaryEdges as Edge[]).map(e => e.id);
        }
        return { shapeVertexIds, shapeEdgeIds };
    }

    

    /**
   * Add Panels to the selected roof or roof-shape drawn by user
   * @param {Object3D} selectedRoof - the Parent roof group Object which contains all Roof Geometry.
   * @param {PanelArray} panelConfig - config properties for the panels to be added.
   * @return true if panels are added successfully
   */
    AddPanelbySelection(selectedRoof: Object3D, panelConfig?: PanelArray, triggerURSnapshot?: boolean) {
        try {
            const {shapeVertexIds, shapeEdgeIds, panelsUserdataArray, panelStoreData, frames, isExisting, eastWestCount} = this.calculatePanelBySelection(selectedRoof, panelConfig);
            if(shapeVertexIds && shapeEdgeIds && panelsUserdataArray && panelStoreData && frames && eastWestCount){
                const addToStore = this.storeUtil.storePanels(shapeVertexIds, shapeEdgeIds, panelsUserdataArray, panelStoreData, frames, eastWestCount, isExisting ? panelConfig : undefined,triggerURSnapshot);

                // validate and fix any visibility sync issues after panel addition
                if (addToStore) {
                    this.validateAndFixVisibilitySyncAsync()
                        .catch(error => console.error('Error syncing visibility after panel addition:', error));
                }
                
                return addToStore ;
            }else{
                return false;
            }
        } catch (error: any) {
            if (this.drawActive) {
                this.terminatePanelDraw();
            }
            const message = `${this.translateMsg('addPnlsErr')} ` + (error.message ?? "");
            console.warn(message);
            console.error('AddPanels Error: ' + error.stack);
            return false;
        }
    }

    AddMultiplePanelsbySelection(selectedRoof: Object3D, panelConfig?: PanelArray): any {
        try {
            const {shapeVertexIds, shapeEdgeIds, panelsUserdataArray, panelStoreData, frames, isExisting, eastWestCount} = this.calculatePanelBySelection(selectedRoof, panelConfig);
            //this.storeUtil.storePanels(shapeVertexIds, shapeEdgeIds, panelArrayGroup, panelStoreData, frames, isExisting ? panelConfig : undefined);
            return {shapeVertexIds, shapeEdgeIds, panelsUserdataArray, panelStoreData, frames, isExisting, eastWestCount};
        } catch (error: any) {
            if (this.drawActive) {
                this.terminatePanelDraw();
            }
            const message = `${this.translateMsg('addPnlsErr')} ` + (error.message ?? "");
            console.warn(message);
            console.error('AddPanels Error: ' + error.stack);
            return false;

        }
    }

    getInitialAzim(panelConfig: PanelArray) {
        const storeRoof = this.GetStoreRoofSection(panelConfig.roofId);
        const roof = this.engServ.scene.getObjectByName(panelConfig.roofId);
        const roofPlane = roof?.getObjectByName(meshTypeEnum.roofPlane) as Mesh;
        if (!storeRoof || !roofPlane) return panelConfig.azimuth;
        const roofCenter = Util.getCenter(roofPlane);
        const isFlatRoof = storeRoof.pitch <= flatRoofDefaults.pitch;
        const isEastWest = panelConfig.arrayType == '2';
        const isFlushMount = panelConfig.arrayType == '0';
        if (!isFlatRoof && (isFlushMount)) return storeRoof.azimuth;
        if (!isFlatRoof && panelConfig.arrayType == '1' && panelConfig.panelTilt === 0) return storeRoof.azimuth;
        const [edgeLeft, edgeRight] = this.storeUtil.GetRoofRidgeVertices(storeRoof);
        if (!edgeLeft || !edgeRight) {
            throw new Error("Unable to find gutter and ridge");
        }
        const azimuthFromEdge = Util.GetAzimuthFromEdge(edgeLeft, edgeRight, roofCenter);
        return azimuthFromEdge;

    }

    createPanelMeshes(
        validProjectedPanelFrameCorner3D: Vector3[][], 
        panelConfig: PanelArray, 
        gutterVector: Vector3, 
        roofConfirmedPlane: Plane,
        roofArea: number,
        roofPolygon: Vector3[],

    ) {
        const panelGeom = new PlaneGeometry( Util.getMeasurementFeetToPixel(panelConfig.panelWidth),  Util.getMeasurementFeetToPixel(panelConfig.panelLength));
        const maxPossiblePanels = this.calculateMaxPossiblePanels(panelGeom, roofArea, panelConfig.panelTilt, panelConfig.roofTilt);
        const frameHeight = Util.DEFAULT_PANEL_ARRAY_MARGIN + Util.getMeasurementFeetToPixel(panelConfig.frameHeight);

        const panelsUserdataArray: Array<MeshUserData> = [];
        const frames: Frame[] = [];
        const isEastWest = panelConfig.arrayType == '2';//TODO: change to east west
        let pillarInstanceMesh : InstancedMesh | undefined;
        if ((panelConfig.frameHeight > 0 || panelConfig.panelTilt > 0) && !isEastWest ) {
            pillarInstanceMesh = this.structureGeometryService.createPillarInstanceMesh(maxPossiblePanels, validProjectedPanelFrameCorner3D.length);
        }
       validProjectedPanelFrameCorner3D.forEach((projectedPanelFramePts, index) => {
            const projectedPanels = this.createPanelPointsFromFrame(projectedPanelFramePts, panelConfig);
            const z1panelIds:string[] = [];
            const z2panelIds:string[] = [];
            const frameGroup: Mesh<BufferGeometry, Material | Material[]>[] = [];
            const az1frameId = Util.generateStoreId(storeIdPrefix.frame);
            const az2frameId = Util.generateStoreId(storeIdPrefix.frame);
            projectedPanels.forEach((panelPts, i) => {
                const id = Util.generateStoreId(storeIdPrefix.singlePanel);
                const panelUserData = new MeshUserData(id, meshTypeEnum.panelMesh);
                if (isEastWest && i >= projectedPanels.length / 2) {
                    panelUserData.frameId = az2frameId;
                    panelUserData.azimuth = calculateAzimuth2(panelConfig.azimuth); //(panelConfig.azimuth + 180) % 360;
                    z2panelIds.push(id);
                } else {
                    panelUserData.frameId = az1frameId;
                    panelUserData.azimuth = panelConfig.azimuth;
                    z1panelIds.push(id);
                }
                panelUserData.orientation = panelConfig.orientation;
                const mesh = Util.drawPolygon(panelPts, meshTypeEnum.panelMesh);
                mesh.translateZ(0.1); // move panels by 0.1 units to disable flickering;
                mesh.material = new MeshStandardMaterial({
                    map: this.panelTexture.clone(),
                    side: DoubleSide,
                    transparent: true,
                });
                mesh.userData = panelUserData;
                mesh.name = id;
                frameGroup.push(mesh);
            });
            const tilttedProjectedFramePoints = this.tiltPanelFrame(frameGroup, projectedPanelFramePts, panelConfig.panelTilt, gutterVector, isEastWest);
            const frame: Frame = {
                id: frameGroup[frameGroup.length - 1]?.userData.frameId,
                panelIds: frameGroup[frameGroup.length - 1]?.userData.frameId == az1frameId ? z1panelIds : z2panelIds,
                panelArrayId: panelConfig.id,
                isDefaultStructure : true,
                pillarIds: [index*4, index*4+1, index*4+2, index*4+3]
            }
            frameGroup.forEach(p=>{
              const panelNormal = Util.getMeshNormal(p);
              if(panelNormal.z<0)panelNormal.negate();
              const panelVertices = Util.getMeshVertices(p);
              const panelAzim =  new Vector3().copy(panelVertices[2]).sub(panelVertices[3]).normalize();
              const panelCenter = Util.getCenter(p);

              const q1 = new Quaternion().setFromUnitVectors(new Vector3(0,0,1), panelNormal);
              const q2 = new Quaternion().setFromUnitVectors(new Vector3(1,0,0).applyQuaternion(q1), panelAzim);


              const tempObj = new Mesh();
              if(panelConfig.orientation == PanelOrientation.landscape){
                tempObj.rotateOnAxis(new Vector3(0,0,1), Math.PI / 2);
              }
              tempObj.applyQuaternion(q1);
              tempObj.applyQuaternion(q2);
              tempObj.position.add(panelCenter);
              tempObj.updateMatrix();
              tempObj.updateMatrixWorld();
              (p.userData as MeshUserData).matrix = tempObj.matrixWorld;
              panelsUserdataArray.push((p.userData as MeshUserData));
            })
            frames.push(frame);
            if(pillarInstanceMesh){
                const originalFramePoints = this.structureGeometryService.getFramePointsFromProjectedFramePoints(tilttedProjectedFramePoints, panelConfig);
                const pillarBuffer = this.structureGeometryService.createPillarPositionAndHeightBuffer(originalFramePoints, roofConfirmedPlane, panelConfig);
                this.structureGeometryService.populatePillarInstanceMeshAtIndex(pillarInstanceMesh,pillarBuffer, frameHeight, index);
                // Hide pillars that fall outside the roof boundary (overhanging panels)
                const pillarIndices = [index * 4, index * 4 + 1, index * 4 + 2, index * 4 + 3];
                this.structureGeometryService.hidePillarsOutsideRoof(pillarInstanceMesh, pillarIndices, roofPolygon);
            }
        });

        const panelM = new MeshStandardMaterial({
            map: this.panelTexture.clone(),
            side: DoubleSide,
            transparent: true,
        });
        const panelsUserdataArrayLength = panelsUserdataArray.length;

        const panelInstanceMesh = new InstancedMesh(panelGeom, panelM, maxPossiblePanels); //Making count sufficiently large to accomodate single panels
        InstancedMeshUtil.init(panelInstanceMesh);
        InstancedMeshUtil.setPanelShader(panelInstanceMesh);
        panelInstanceMesh.name = meshTypeEnum.panelArray;
        (panelInstanceMesh.userData as MeshUserData).meshtype = meshTypeEnum.instancedMesh;
        (panelInstanceMesh.userData as MeshUserData).maxInstanceCount = panelInstanceMesh.count;

        panelsUserdataArray.forEach((p,i)=>{
          panelInstanceMesh.setMatrixAt( i, p.matrix as Matrix4);
          panelInstanceMesh.setColorAt( i, new Color(0xffffff));
          p.instanceId = i;
        });

        panelInstanceMesh.count = panelsUserdataArrayLength;
        panelInstanceMesh.renderOrder = renderOrders.panelArray;

        return { panelsUserdataArray, frames, panelInstanceMesh, pillarInstanceMesh};
    }

    calculateMaxPossiblePanels(panelGeom: PlaneGeometry, roofArea: number, panelTilt: number, roofTilt: number){
        const panelArea = Util.calculateArea(new Mesh(panelGeom));
        const projectedArea = panelArea * Math.cos(Util.convertDegreeToRadian(panelTilt+ roofTilt));
        return Math.floor(roofArea * Math.cos(Util.convertDegreeToRadian(roofTilt)) / projectedArea);
    }
    createPanelPointsFromFrame(framePts: Vector3[], panelConfig: PanelArray){
        const isEastWest = panelConfig.arrayType == '2';//TODO: change to east west
        const isLandscape = panelConfig.orientation == PanelOrientation.landscape;
        const clampSpace = Util.getMeasurementFeetToPixel(panelConfig.clampSpace);
        const orientedPanelHeight = isLandscape ? Util.getMeasurementFeetToPixel(panelConfig.panelWidth) : Util.getMeasurementFeetToPixel(panelConfig.panelLength);
        const orientedPanelWidth = isLandscape ? Util.getMeasurementFeetToPixel(panelConfig.panelLength) : Util.getMeasurementFeetToPixel(panelConfig.panelWidth);
        const columnVector = framePts[1].clone().sub(framePts[0]).normalize();
        const rowVector = framePts[3].clone().sub(framePts[0]).normalize();
        const panelX = columnVector.clone().multiplyScalar(orientedPanelWidth)
        const panelY = rowVector.clone().multiplyScalar(orientedPanelHeight)
        const xDir =  columnVector.clone().multiplyScalar(orientedPanelWidth+clampSpace+Util.getMeasurementFeetToPixel(constants.PanlePlacementOffset));
        const yDir =  rowVector.clone().multiplyScalar(orientedPanelHeight+clampSpace+Util.getMeasurementFeetToPixel(constants.PanlePlacementOffset));
        const panels = [];
        for (let i = 0; i < panelConfig.noOfRows; i++) {
            for (let j = 0; j < panelConfig.noOfColumns; j++) {
                const a = framePts[0].clone().addScaledVector(xDir, j).addScaledVector(yDir, i);
                const b = a.clone().add(panelX);
                const c = b.clone().add(panelY);
                const d = a.clone().add(panelY);
                panels.push([a, b, c, d])
            }
        }
        if (isEastWest) {
            for (let i = 0; i < panelConfig.noOfRows; i++) {
                for (let j = 0; j < panelConfig.noOfColumns; j++) {
                    const a = framePts[3].clone().addScaledVector(xDir, j).addScaledVector(yDir, -i);
                    const b = a.clone().add(panelX);
                    const c = b.clone().sub(panelY);
                    const d = a.clone().sub(panelY);
                    panels.push([a, b, c, d])
                }
            }
        }
        return panels;
    }

    getPanelsFromRoof(selectedRoof: Object3D, allPanels: boolean) {
        const roofId = selectedRoof.name;
        const panelMeshes: Object3D[] = [];
        let isEastWest = false;

        this.store.select(fromPanelArraySelectors.selectPanelArraysByRoofId(roofId))
            .pipe(take(1))
            .subscribe(roofPanelArrays => {
                for (const panelArray of roofPanelArrays) {
                    const panelArrayGroup = selectedRoof.getObjectByName(panelArray.id)?.getObjectByName(meshTypeEnum.panelArray);
                    if (!panelArrayGroup) continue;

                    // Collect panels based on the `allPanels` condition
                    panelArrayGroup.children.forEach(p => {
                        if (allPanels || !p.userData.removed) {
                            panelMeshes.push(p);
                        }
                    });

                    // Set isEastWest if any panelArray is of arrayType '2'
                    if (panelArray.arrayType === '2') {
                        isEastWest = true;
                    }
                }
            });

        return { panelMeshes, isEastWest };
    }


    updatePanelsOnObstacleOrRoofChanges(roofId: string) {
        const selectedRoof = this.engServ.scene.getObjectByName(roofId);
        const storeRoof = this.GetStoreRoofSection(roofId);

        if (!selectedRoof || !storeRoof) {
            console.error(`Unable to identify roof with id: ${roofId}`);
            return;
        }

        this.store.select(fromPanelArraySelectors.selectPanelArraysByRoofId(roofId))
            .pipe(take(1))
            .subscribe(roofPanelArrays => {
                if(roofPanelArrays && roofPanelArrays.length){ // Only fetch data if there is any panelArray
                const [gutterLeft, gutterRight] = this.storeUtil.GetRoofGutterVertices(storeRoof);
                if (gutterLeft && gutterRight) {
                    const roofNormal = new Vector3().copy((selectedRoof.userData as MeshUserData).roofNormal as Vector3);
                    const keepoutPointsResult = this.getAllKeepOutPointsOnRoof(storeRoof);
                    const keepoutPoints = Object.values(keepoutPointsResult.keepouts);

                    roofPanelArrays.forEach(panelArray => {
                        const rootPanelsGroup = selectedRoof.getObjectByName(panelArray.id);
                        const panelInstanceMesh = rootPanelsGroup?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
                        const pillarInstanceMesh = rootPanelsGroup?.getObjectByName(meshTypeEnum.pillerArray) as InstancedMesh;
                        const invisibleIndices = this.invisiblePanelsOverlappingWithObstacles(panelArray, panelInstanceMesh, keepoutPoints, keepoutPointsResult.overlappingRoofs);
                        if (pillarInstanceMesh)                       
                            this.structureGeometryService.updatePillarsOnObstacleOrRoofChanges(panelArray, invisibleIndices, pillarInstanceMesh, panelInstanceMesh);       
                        
                    });
                }
                }
            })
    }

    /**
     *  requestAnimationFrame to ensure rendering cycle completion
     */
    private waitForSceneUpdate(): Promise<void> {
        return new Promise((resolve) => {
            // Wait for multiple frames to ensure all updates are processed
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    resolve();
                });
            });
        });
    }

    /**
     * waits for store operations to complete using observable completion
     */
    private waitForStoreUpdate(): Promise<void> {
        return new Promise((resolve) => {
            // Use a microtask to wait for current execution stack to complete
            Promise.resolve().then(() => {
                // Then wait one more tick for store updates to propagate
                Promise.resolve().then(() => {
                    resolve();
                });
            });
        });
    }

    /**
     * ensure both scene and store are ready
     */
    private async waitForOperationCompletion(): Promise<void> {
        await this.waitForStoreUpdate();
        await this.waitForSceneUpdate();
    }

    /**
     * Async version of syncStoreVisibilityWithScene that returns a Promise
     */
    private async syncStoreVisibilityWithSceneAsync(panelInstancedMesh: InstancedMesh, panelArray: PanelArray): Promise<void> {
        await this.waitForOperationCompletion();
        return new Promise((resolve) => {
            this.syncStoreVisibilityWithScene(panelInstancedMesh, panelArray);
            // Wait for the store update to complete
            this.waitForStoreUpdate().then(() => resolve());
        });
    }

    /**
     * sync store panel visibility with scene visibility for all panels in a panel array
     * @param panelInstancedMesh The instanced mesh containing panels
     * @param panelArray The panel array configuration
     */
    private syncStoreVisibilityWithScene(panelInstancedMesh: InstancedMesh, panelArray: PanelArray) {
        try {
            // Get scene visibility array
            const sceneVisibilityArray = InstancedMeshUtil.getVisibilityArray(panelInstancedMesh);

            this.store.select(fromPanelSelectors.selectPanelsByIds(panelArray.panelIds)).pipe(take(1)).subscribe(storePanels => {
                const panelsToUpdate: Panel[] = [];
                let visibilityChanged = false;

                storePanels.forEach(storePanel => {
                    if (storePanel && storePanel.instanceId < sceneVisibilityArray.length) {
                        const sceneVisible = sceneVisibilityArray[storePanel.instanceId] === 1;

                        // Only update if visibility differs
                        if (storePanel.visible !== sceneVisible) {
                            const updatedPanel = JSON.parse(JSON.stringify(storePanel));
                            updatedPanel.visible = sceneVisible;
                            panelsToUpdate.push(updatedPanel);
                            visibilityChanged = true;
                        }
                    }
                });

                // Dispatch store updates only if changes are needed
                if (visibilityChanged && panelsToUpdate.length > 0) {
                    this.store.dispatch(fromPanelActions.UpsertMany({ panels: panelsToUpdate }));

                    // Update panel array counts
                    this.updatePanelArrayCounts(panelArray, storePanels.map(p =>
                        panelsToUpdate.find(updated => updated.id === p?.id) || p
                    ).filter(p => p !== null) as Panel[]);
                }
            });
        } catch (error) {
            console.error('Error synchronizing store visibility with scene:', error);
        }
    }

    /**
     * Updates panel array counts based on visible panels
     */
    private updatePanelArrayCounts(originalPanelArray: PanelArray, allPanels: Panel[]) {
        const isEastWest = originalPanelArray.arrayType === '2';
        let noOfPanelEast = 0;
        let noOfPanelWest = 0;
        let noOfPanels = 0;

        allPanels.forEach(panel => {
            if (panel.visible) {
                if (isEastWest && panel.azimuth === originalPanelArray.azimuth2) {
                    noOfPanelWest++;
                } else {
                    noOfPanelEast++;
                }
                noOfPanels++;
            }
        });

        const updatedPanelArray = JSON.parse(JSON.stringify(originalPanelArray));
        updatedPanelArray.numberOfPanels = noOfPanels;
        updatedPanelArray.noOfPanelEast = isEastWest ? noOfPanelEast : noOfPanels;
        updatedPanelArray.noOfPanelWest = noOfPanelWest;
        updatedPanelArray.totalWatts = updatedPanelArray.wattsPerModule * noOfPanels;

        this.store.dispatch(fromPanelArrayActions.UpsertOne({ panelArray: updatedPanelArray }));
    }

    /**
   * panel selection filter that checks both scene and store visibility
   * @param intersections The raycast intersection results
   * @returns Filtered intersections for visible panels only
   */
    filterVisiblePanelIntersections(intersections: Intersection[]): Intersection[] {
        return intersections.filter(intersection => {
            if (intersection.instanceId !== undefined) {
                // Check scene visibility (this is the primary check for performance)
                const sceneVisible = InstancedMeshUtil.getVisibilityAt(intersection.object as InstancedMesh, intersection.instanceId);
                return sceneVisible;
            }

            return intersection.object.visible && !intersection.object.name.includes('vertex');
        });
    }


    GetVertsFromMesh(mesh: Mesh, convertToWorld: boolean = true) {
        const roofPosArray = (mesh.geometry.attributes.position as BufferAttribute).array;
        const roofVerts: Vector3[] = [];

        for (let i = 0; i < roofPosArray.length; i += 3) {
            const vertexPt = new Vector3(roofPosArray[i], roofPosArray[i + 1], roofPosArray[i + 2]);
            if (convertToWorld) {
                mesh.localToWorld(vertexPt);
            }
            roofVerts.push(vertexPt);
        }
        return roofVerts;
    }

    transparentPanels(instanceMesh: InstancedMesh, transparent: Boolean) {
        InstancedMeshUtil.setMultipleTextures(instanceMesh, [],transparent?PanelTextureEnum.Transparent: PanelTextureEnum.Normal, true);
    }

    setPanelShade(selectedRoof: Object3D, shadeData: { [key: string]: any }[]) {
        const roofId = selectedRoof.name;
        this.store.select(fromPanelArraySelectors.selectPanelArraysByRoofId(roofId))
        .pipe(take(1))
        .subscribe(roofPanelArrays => {
            roofPanelArrays.forEach(panelArray => {
                const rootPanelsGroup = selectedRoof.getObjectByName(panelArray.id);
                const panelInstanceMesh = rootPanelsGroup?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;

                const shadeValues = Object.keys(shadeData[0] || {});
                this.store.select(fromPanelSelectors.selectPanelsByIds(shadeValues)).pipe(take(1)).subscribe(panels=> {
                    for(let i = 0; i < panels.length; i++){
                        const panel = panels[i];
                        if (panel == undefined) continue;
                        InstancedMeshUtil.setShadedAt(panelInstanceMesh, panel.instanceId, shadeData[0][panel.id]);
                    }
                })

                InstancedMeshUtil.setMultipleTextures(panelInstanceMesh, [], PanelTextureEnum.Shaded, true);
            })
        })
    }

    highlightPanels(panelIds: string[]) {

        this.store
          .select(fromPanelSelectors.selectPanelsByIds(panelIds))
          .pipe(take(1))
          .subscribe((panels) => {
            try {
                if (!panels || panels.length <= 0) return;
            panels = JSON.parse(JSON.stringify(panels)) as (Panel | undefined)[];
            const groupedPanels = this.groupPanels(panels.filter(p=> p != undefined));
            for (let i = 0; i < Object.keys(groupedPanels).length; i++) {
              const associationId = Object.keys(groupedPanels)[i];
              const roofMesh = this.engServ.scene.getObjectByName(associationId) as Mesh;
              const instancedMesh = roofMesh.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
              const panelInstanceIds = [];

              for (let i = 0; i < groupedPanels[associationId].length; i++) {
                const instanceId = groupedPanels[associationId][i]?.instanceId;
                if (instanceId !== null && instanceId !== undefined) {
                  panelInstanceIds.push(instanceId);
                }
              }
              InstancedMeshUtil.setMultipleTextures(
                instancedMesh,
                panelInstanceIds,
                  PanelTextureEnum.Highlight
              );

            }
            } catch (error) {
                console.log("Highlight Panels Error: ", error);
                
            }
          });
    }

    groupPanels(panels: Panel[]) {
      return panels.reduce((groupedPanels: {[key:string]:Panel[]}, panel) => {
          const { association } = panel;
          if (!groupedPanels[association]) {
              groupedPanels[association] = [];
          }
          groupedPanels[association].push(panel);
          return groupedPanels;
      }, {});
  }

    hoverPanel(instanceId: number, panelArrayId: string) {
        let texture;
        const instancedMeshParent = this.engServ.scene.getObjectByName(panelArrayId);
        const instancedMesh = instancedMeshParent?.children[0] as InstancedMesh;

        texture = InstancedMeshUtil.getTextureAt(
            instancedMesh,
            (instanceId),
        )
        InstancedMeshUtil.setTextureAt(
            instancedMesh,
            (instanceId),
            PanelTextureEnum.Hover
        );

        return texture;
    }

    restorePanels(panelIds: string[], shaded: boolean = false) {
        this.store
        .select(fromPanelSelectors.selectPanelsByIds(panelIds))
        .pipe(take(1))
        .subscribe((panels) => {
            try {
                if (panels.length <= 0) return;

                panels = JSON.parse(JSON.stringify(panels)) as (Panel | undefined)[] ;
                if (!panels || panels.length <= 0) return;
                panels = JSON.parse(JSON.stringify(panels));
                const groupedPanels = this.groupPanels(panels.filter(p=> p != undefined));
                for (let i = 0; i < Object.keys(groupedPanels).length; i++) {
                    const associationId = Object.keys(groupedPanels)[i];
                    const roofMesh = this.engServ.scene.getObjectByName(associationId) as Mesh;
                    const instancedMesh = roofMesh.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
                    const panelInstanceIds = [];

                    for (let i = 0; i < groupedPanels[associationId].length; i++) {
                        const instanceId = groupedPanels[associationId][i]?.instanceId;
                        if (instanceId != undefined) {
                            panelInstanceIds.push(instanceId);
                        }
                    }
                    InstancedMeshUtil.setMultipleTextures(
                        instancedMesh,
                        panelInstanceIds,
                        shaded ? PanelTextureEnum.Shaded : PanelTextureEnum.Normal
                    );

                }
            } catch (error) {
                console.log("Restore Panels Error: ", error);

            }

        });
    }
    togglePanels(selectedRoof: Object3D, show: boolean) {
        const roofId = selectedRoof.name;
        this.store.select(fromPanelArraySelectors.selectPanelArraysByRoofId(roofId))
            .pipe(take(1))
            .subscribe(roofPanelArrays => {
                roofPanelArrays.forEach(panelArray => {
                    const rootPanelsGroup = selectedRoof.getObjectByName(panelArray.id);
                    const panelArrayGroup = rootPanelsGroup?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
                    const pillarInstanceMesh = rootPanelsGroup?.getObjectByName(meshTypeEnum.pillerArray) as InstancedMesh;

                    // Guard against a store panel array whose scene mesh is missing 
                    if (panelArrayGroup) {
                        panelArrayGroup.visible = show;
                    }
                    if (pillarInstanceMesh) {
                        pillarInstanceMesh.visible = show;
                    }

                });
            })
    }

    savePanelTexture(selectedRoof: Object3D) {
        const roofId = selectedRoof.name;
        this.store.select(fromPanelArraySelectors.selectPanelArraysByRoofId(roofId))
            .pipe(take(1))
            .subscribe(roofPanelArrays => {
                roofPanelArrays.forEach(panelArray => {
                    const rootPanelsGroup = selectedRoof.getObjectByName(panelArray.id);
                    const panelInstanceMesh = rootPanelsGroup?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
                    // Guard against a store panel array whose scene mesh is missing; previously this
                    // threw "Cannot read properties of undefined (reading 'material')" during shading.
                    if (panelInstanceMesh) {
                        this.defaultPanelMaterial = panelInstanceMesh.material as MeshStandardMaterial;
                    }
                });
            })
    }

    restorePanelMaterial(selectedRoof: Object3D) {
        const roofId = selectedRoof.name;
        this.store.select(fromPanelArraySelectors.selectPanelArraysByRoofId(roofId))
            .pipe(take(1))
            .subscribe(roofPanelArrays => {
                roofPanelArrays.forEach(panelArray => {
                    const rootPanelsGroup = selectedRoof.getObjectByName(panelArray.id);
                    const panelInstanceMesh = rootPanelsGroup?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
                    if (panelInstanceMesh && this.defaultPanelMaterial) {
                        panelInstanceMesh.material = this.defaultPanelMaterial;
                    }else{
                        console.warn("Default panel material not found");
                    }
                });
            })
    }

    private setPanelDirectionalMaterial(
        panelInstanceMesh: InstancedMesh,
        material: MeshStandardMaterial,
        customPanelMaterial: ShaderMaterial,
        directionalLight: DirectionalLight
    ): void {
        const { panelMesh, matrix } = this.getPanelMesh(panelInstanceMesh);
        panelMesh.geometry.applyMatrix4(matrix);
        let panelNormal = Util.getMeshNormal(panelMesh);

        if (panelNormal) {
            if (panelNormal.z < 0.0) {
                panelNormal = panelNormal.negate();
            }
            // customPanelMaterial.uniforms.lightDirection.value.copy(directionalLight.position).normalize();
            const lightDirection = directionalLight.position.clone().normalize();
            const dotProduct = panelNormal.dot(lightDirection);

            (panelInstanceMesh as Mesh).material = dotProduct > 0 ? material : customPanelMaterial;
        }
    }

    togglePanelsWhite(selectedRoof: Object3D, directionalLight: DirectionalLight) {
        const roofId = selectedRoof.name;
        const material = new MeshStandardMaterial({
            map: this.panelWhiteTexture2.clone(),
            side: DoubleSide,
            color: 0xffffff,
            transparent: true,
        });
        const customPanelMaterial = new ShaderMaterial({
            uniforms: UniformsUtils.merge([
                UniformsLib.common,
                UniformsLib.lights,
                {
                    lightDirection: { value: new Vector3() },
                    shadowIntensity: { value: 1.0 }
                }
            ]),
            vertexShader: `
                varying vec3 vNormal;
                varying vec3 vPosition;
                void main() {
                    vec4 worldPosition = instanceMatrix * vec4(position, 1.0);
                    vNormal = normalize(normalMatrix * normal);
                    vPosition = (modelViewMatrix * worldPosition).xyz;
                    gl_Position = projectionMatrix * modelViewMatrix * worldPosition;
                }
            `,
            fragmentShader: `
                uniform vec3 lightDirection;
                uniform float shadowIntensity;
                varying vec3 vNormal;
                varying vec3 vPosition;
                void main() {
                    float dotProduct = dot(vNormal, lightDirection);
                    float shadow = max(dotProduct, 0.0);
                    vec3 baseColor = vec3(1.0); // Base color is white
        
                    if (dotProduct > 0.0) {
                        // Normal shading when sun is in front
                        gl_FragColor = vec4(baseColor * shadow, 1.0);
                    } else {
                        // Custom behavior when sun is behind
                        shadow = 1.0; // Ensure the panel remains white
                        gl_FragColor = vec4(baseColor * shadow, 1.0);
                    }
                }
            `,
            lights: true,
            defines: {
                INSTANCED: ''
            }
        });
        this.store.select(fromPanelArraySelectors.selectPanelArraysByRoofId(roofId))
            .pipe(take(1))
            .subscribe(roofPanelArrays => {
                if (roofPanelArrays[0]?.arrayType == '2') { 
                    const rootPanelsGroup = selectedRoof.getObjectByName(roofPanelArrays[0].id);
                    const panelInstanceMesh = rootPanelsGroup?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
                    const east = selectedRoof.getObjectByName(`${meshTypeEnum.panelArray}-east`);
                    const west = selectedRoof.getObjectByName(`${meshTypeEnum.panelArray}-west`);
                    if (east) {
                        east.parent = new Object3D();
                        east.parent.name = panelInstanceMesh.parent?.name ?? '';
                        
                        this.setPanelDirectionalMaterial(east as InstancedMesh, material, customPanelMaterial, directionalLight);
                    }
                    if (west) {
                        west.parent = new Object3D();
                        west.parent.name = panelInstanceMesh.parent?.name ?? '';
                        this.setPanelDirectionalMaterial(west as InstancedMesh, material, customPanelMaterial, directionalLight);
                    }
                } else {
                    roofPanelArrays.forEach(panelArray => {
                        const rootPanelsGroup = selectedRoof.getObjectByName(panelArray.id);
                        const panelInstanceMesh = rootPanelsGroup?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
                        const visiblePanels = selectedRoof.getObjectByName(`${meshTypeEnum.panelArray}-hidden`);
                        if (visiblePanels) {
                            visiblePanels.parent = new Object3D();
                            visiblePanels.parent.name = panelInstanceMesh.parent?.name ?? '';

                            this.setPanelDirectionalMaterial(visiblePanels as InstancedMesh, material, customPanelMaterial, directionalLight);
                        }
                    });
                }
            })
    }

    panelConfigCalculator(existingPanelArray: PanelArray, fieldUpdated: string | undefined = undefined, roofId: string): any {
        const selectedRoof = this.engServ.scene.getObjectByName(roofId);
        if (!selectedRoof) {
            try {
                throw new Error("Unable to identify roof with id: " + roofId);
            } catch (err) {
                console.log(err);
                return;
            }
        }
        if (existingPanelArray == undefined) {
            this.store.select(fromPanelArraySelectors.selectPanelArraysByRoofId(roofId))
                .pipe(take(1))
                .subscribe(roofPanelArrays => {
                    roofPanelArrays.forEach(panelArray => {
                        existingPanelArray = panelArray;
                    });
                })
        }
        if (!existingPanelArray) return { selectedRoof: null, panelConfig: null };
        //use this function to update panel array from RHS
        const rootPanelsGroup = selectedRoof.getObjectByName(existingPanelArray.id);
        const panelArrayGroup = rootPanelsGroup?.getObjectByName(meshTypeEnum.panelArray);
        if (panelArrayGroup) {
            this.store.dispatch(fromPanelActions.DeleteMany({ panelIds: existingPanelArray.panelIds }));
            if (existingPanelArray.frameIds)
                this.store.dispatch(fromFrameActions.DeleteMany({ frameIds: existingPanelArray.frameIds }));
            Util.removeObjWithChildren(panelArrayGroup);

        }
        rootPanelsGroup?.clear();
        const panelConfig: PanelArray = JSON.parse(JSON.stringify(existingPanelArray));
        const oldAzimuth = panelConfig.azimuth;
        const initialAzim = this.getInitialAzim(panelConfig);
        if (fieldUpdated == 'arrayType' || fieldUpdated == 'alignPanels') {
            panelConfig.azimuth = initialAzim;
            panelConfig.azimuth2 = calculateAzimuth2(panelConfig.azimuth);
        }
        const isTiltCausingAzimuthUpdate = fieldUpdated == 'panelTilt' && (panelConfig.roofTilt >0 ||  (panelConfig.roofTilt ==0 && (panelConfig.panelTilt == 0 &&initialAzim!= oldAzimuth)));
        if (isTiltCausingAzimuthUpdate){
            panelConfig.azimuth = initialAzim;
            panelConfig.azimuth2 = calculateAzimuth2(panelConfig.azimuth);
        }

        if (fieldUpdated == 'arrayType') {
            panelConfig.orientation = panelConfig.arrayType == '2' ? PanelOrientation.landscape : PanelOrientation.portrait;
            panelConfig.interrowspacing = panelConfig.arrayType == '2' ? this.defaultInterRowSpace : this.calculateInterRowSpacing(panelConfig, panelConfig.roofTilt);
            panelConfig.defaultInterrowspacing = panelConfig.interrowspacing;
            // Fetching user preferences for panel tilt and inter-row spacing
            // This is done for change of panel array type
            this.store.select(fromMetaDataSelectors.selectPreference)
                .pipe(take(1))
                .subscribe((obj: any) => {
                    const preferencesObj = obj?.preferencesObj;
                    if (!preferencesObj) return;
                    const panelTiltValue = preferencesObj?.system_design?.panel_tilt?.value;
                    if (panelTiltValue !== undefined && panelConfig
                        && typeof panelTiltValue === 'number' && panelTiltValue >= 0 && panelTiltValue <= 90) {
                        panelConfig.panelTilt = panelTiltValue;
                    }
                    const interRowSpaceValue = preferencesObj?.system_design?.inter_row_space?.value;
                    if (interRowSpaceValue !== undefined && panelConfig
                        && typeof interRowSpaceValue === 'number' && interRowSpaceValue >= 0) {
                        panelConfig.interrowspacing = interRowSpaceValue;
                    }
                    
                    // Set panel degradation from preferences
                    if (
                        preferencesObj?.system_design?.panel_degradation !== undefined &&
                        preferencesObj?.system_design?.panel_degradation?.visible &&
                        preferencesObj?.system_design?.panel_degradation != null
                    ) {
                        const degradationValue = preferencesObj.system_design.panel_degradation.value;
                        if (typeof degradationValue === 'number' && degradationValue >= 0 && degradationValue <= 100) {
                            panelConfig.degradation = degradationValue;
                        }
                    }

                    // Set panel orientation from preferences (overwrite panel config default if preference exists)
                    const panelOrientationValue = preferencesObj?.system_design?.panel_orientation?.value;
                    if (panelOrientationValue !== undefined && panelOrientationValue !== null && panelConfig
                        && Object.values(PanelOrientation).includes(panelOrientationValue)) {
                        panelConfig.orientation = panelOrientationValue;
                    }

                    // Set panel alignment from preferences (overwrite panel config default if preference exists)
                    const panelAlignmentValue = preferencesObj?.system_design?.panel_alignment?.value;
                    if (panelAlignmentValue !== undefined && panelAlignmentValue !== null && panelConfig
                        && Object.values(ArrayAlignment).includes(panelAlignmentValue)) {
                        panelConfig.alignment = panelAlignmentValue;
                    }
                });
        }


        if(oldAzimuth != panelConfig.azimuth && fieldUpdated != 'azimuth') {
            this.notificationService.sendMessage({
                message: this.translateMsg('azimuthUpdateMsg', true).
                replace("old", `${oldAzimuth}°`).replace("new", `${panelConfig.azimuth}°`),
                type: NotificationType.success,
                positionClass: 'toast-bottom-left',
                timeOut: 2500
            });
        }
        return { selectedRoof: selectedRoof, panelConfig: panelConfig };
    }

    recreateExistingMultiplePanelArrays(existingPanelArrays: PanelArray[], fieldUpdated: string | undefined = undefined, triggerURSnapshot?: boolean){
        const panelToUpdate: any = [];
        const panelsToBeDeleted: PanelArray[] = [];
        existingPanelArrays.forEach(panelarr=>{
            const {selectedRoof, panelConfig} = this.panelConfigCalculator(panelarr, fieldUpdated, panelarr['roofId']);
            const {shapeVertexIds, shapeEdgeIds, panelsUserdataArray, panelStoreData, frames, isExisting, eastWestCount} = this.AddMultiplePanelsbySelection(selectedRoof, panelConfig);
            if(shapeVertexIds && shapeEdgeIds && panelsUserdataArray && panelStoreData && frames && isExisting && eastWestCount){
                panelToUpdate.push({panelArray: panelarr, shapeVertexIds, shapeEdgeIds, panelsUserdataArray, panelStoreData, frames, isExisting, eastWestCount});
            }else{
                panelsToBeDeleted.push(panelarr);
            }
        })
        this.storeUtil.updateMultiplePanelModule(panelToUpdate);

        panelsToBeDeleted.forEach(panelArr=>{
            Util.DeletePanelArrayfromStore(this.store, panelArr);
            this.store.dispatch(fromUiActions.ClearObjectsSelection(true));
            const message = this.translateMsg('delAllPnl');
            console.warn(message);
        });
        if (triggerURSnapshot == undefined || triggerURSnapshot == true) {
          this.store.dispatch(fromUndoRedoActions.TriggerURSnapshot({action: fromPanelArrayActions.UpsertOne, notification: this.translateMsg("Panel Array", false) +' '+ this.translateMsg('design.undoRedo.update',false)}))
        }

    }

    recreateExistingPanelArray(roofId: string, existingPanelArray: PanelArray | undefined = undefined, fieldUpdated: string | undefined = undefined, triggerURSnapshot?: boolean):boolean {
        // if (!existingPanelArray) return;  // throw new Error("No Existing Panel Array");
        const {selectedRoof, panelConfig} = this.panelConfigCalculator(existingPanelArray as any, fieldUpdated, roofId);
        if(selectedRoof && panelConfig){
            const isPanelAdded = this.AddPanelbySelection(selectedRoof, panelConfig, triggerURSnapshot);

            if (!isPanelAdded) {
                this.store.select(fromPanelArraySelectors.selectPanelArraysByRoofId(roofId))
                    .pipe(take(1))
                    .subscribe(roofPanels => {
                        roofPanels?.forEach(panelArr => {
                            Util.DeletePanelArrayfromStore(this.store, panelArr);
                        })
                    })
                this.store.dispatch(fromUiActions.ClearObjectsSelection(true));
                const message = this.translateMsg('delAllPnl');
                console.warn(message);

            }
            return isPanelAdded
        }
        return false
    }

    addDrawVertex(int: Intersection) {

        if (this.selectedBlock) {
            if (this.selectedBlock.name !== int.object.parent?.name) {
                // only allow adding points on same roof
                console.log("Please add vertex on " + this.selectedBlock.name)
                return;

            }
        }
        const point = int.point;
        if (Util.PointsTooClose(this.prevPoint, point)) {
            // this currently helps during double-click - to not create 2 vertices at same point
            console.log('Please click a point that is farther');
            return;
        }

        const vertex = this.tempVertex.clone();
        vertex.position.copy(point);

        const id = Util.generateStoreId(storeIdPrefix.vertex);
        const vertexData = new MeshUserData(id, meshTypeEnum.fittedVertex);
        vertex.userData = vertexData;
        vertex.name = id;

        this.drawVertexList.push(vertex);
        this.panelGroupObj.add(vertex);

        if (this.drawVertexList.length == 1) {
            vertex.material = this.firstVertexMaterial.clone();
            this.selectedBlock = int.object.parent;
            this.selectedBlock?.add(this.panelGroupObj);
        }

        if (this.currentLine) {
            const id = Util.generateStoreId(storeIdPrefix.edge);
            this.currentLine.name = id;

            const vertexData = new MeshUserData(id, meshTypeEnum.fittedEdge);
            this.currentLine.userData = vertexData;

            this.drawEdgeList.push(this.currentLine);
            // store previous line in array before updating the current line based on new vertex
            this.updateCurrline(point, int.object);
        }

        this.prevPoint = point.clone();
        this.currentLine = this.drawline(point, point);
    }

    closePanelDraw() {
        // this.currPoint = this.vertexList[0].position;
        const end = this.drawVertexList[0].clone().position;
        this.currentLine?.geometry.setFromPoints([this.prevPoint, end]);
        // this.addPanelDrawShape(this.drawVertexList);

        // Remove and readd method
        for (let i = this.panelGroupObj.children.length - 1; i >= 0; i--) {
            const child = this.panelGroupObj.children[i];

            // Check if the child is a mesh and has the specified name
            if (child instanceof Mesh && child.name === 'Edge') {
                // Remove the mesh from the group
                this.panelGroupObj.remove(child);
            }
        }

        // Iterate through the vertices array
        for (let i = 0; i < this.drawVertexList.length - 1; i++) {
            const startPoint = this.drawVertexList[i].clone().position;
            const endPoint = this.drawVertexList[i + 1].clone().position;

            // Create an edge and add it to the array
            const edge = this.edgeObj.draw(startPoint, endPoint,  new Color(threeColors.finalVertex));

            // Add the edge's cylinder mesh to the scene
            this.panelGroupObj.add(edge);
        }
        // Connect the last and first vertices to create a closed loop
        const startPoint = this.drawVertexList[this.drawVertexList.length - 1].clone().position;
        const endPoint = this.drawVertexList[0].clone().position;
        const edge = this.edgeObj.draw(startPoint, endPoint,  new Color(threeColors.finalVertex));
        //const edge = new Edges(startPoint, endPoint,  new Color(threeColors.finalVertex));
        this.panelGroupObj.add(edge);
        // this.drawline(this.prevPoint, this.currPoint);

        // this.prevPoint = this.vertexList[0].position;

        // this.extrudeShape();

        // this.drawActive = false;
        this.currentLine = undefined;

        (this.drawVertexList[0].material as MeshBasicMaterial).copy(this.drawVertexList[1].material as MeshBasicMaterial);

        this.generateDrawPanels();

        // return { fittedVertexList: this.fittedVertexList, roofObject: this.rt };
    }

    generateDrawPanels() {
        // Draw panel code below
        if (this.selectedBlock && this.drawPanelGeom) {

            this.AddPanelbySelection(this.selectedBlock);
        }
    }

    updateCurrline(point: Vector3, intersectMesh: Object3D) {
        const hoverMeshname = intersectMesh.name;
        if (this.drawActive && this.currentLine) {
            this.currPoint = point.clone();
            this.currentLine.geometry.setFromPoints([this.prevPoint, this.currPoint]);

            const currPoint = this.drawVertexList[0].clone();
            currPoint.position.copy(point);

            const isMouseOnfirstPt = this.drawVertexList[0].name == hoverMeshname;


            const roofVertices = [...this.drawVertexList];
            if (!isMouseOnfirstPt) {
                // if mouse is on first point, then don't need to add a new vertex
                roofVertices.push(currPoint);
            }
            if (roofVertices.length > 2) {
                this.addPanelDrawShape(roofVertices);
            }
        }
    }

    addPanelDrawShape(points: Mesh[]): void {
        this.drawPanelShape = new Shape(
            points.map((m) => new Vector2(m.position.x, m.position.y))
        );

        const shapeGeo = new ShapeGeometry(this.drawPanelShape);
        if (!this.drawPanelGeom) {
            const shapeMat = new MeshStandardMaterial({
                color: threeColors.drawShapeColor,
                transparent: true,
                opacity: 0.5,
            });
            this.drawPanelGeom = new Mesh(shapeGeo, shapeMat);
            this.drawPanelGeom.name = meshTypeEnum.drawPanelShape;

            this.panelGroupObj.add(this.drawPanelGeom);
        }
        // for (const [i, mesh] of points.entries()) {
        //   if (i == 0) {
        //     shape.moveTo(mesh.position.x, mesh.position.y);
        //   } else {
        //     shape.lineTo(mesh.position.x, mesh.position.y);
        //   }
        // }

        this.drawPanelGeom.geometry = shapeGeo;
        Util.AddHeightTo2dShape(this.drawPanelGeom, points);
        this.drawPanelGeom.position.setZ(constants.FLICKEROFFSET);
    }

    drawline(startPoint: Vector3, endPoint: Vector3): Line {
        const material = new LineBasicMaterial({ color: threeColors.wallColor });

        const geometry = new BufferGeometry().setFromPoints([
            startPoint,
            endPoint,
        ]);

        const line = new Line(geometry, material);
        line.name = 'LineMesh';
        this.currentLine = line;

        this.panelGroupObj.add(line);

        return line;
    }






    getValidPanelFrameCorners(polygonPoints: Vector3[], roofPoints: Vector3[], edgeLeftPoint: Vector3, gutterVector: Vector3, roofNormal: Vector3, edgeRightPoint: Vector3, storeRoof: RoofSection, panelConfig: PanelArray) {
        const roofGeo = this.engServ.scene.getObjectByName(storeRoof.id);
        if (!roofGeo) {
            throw new Error("getValidPanelCorners: cannot find selected roof in threejs");
        }


        // Calculate transformation matrix for converting 3D polygon points to 2D points on the roof surface. This we need to test
        const globalToLocal = Util.calculateRoofPlaneGlobalToLocalMatrix(edgeLeftPoint, gutterVector, roofNormal);
        const localToGlobal = globalToLocal.clone().invert();

        if (Util.debugThreejs) {

            const panelAxesHelper = new AxesHelper(20);
            panelAxesHelper.name = "DebugPanel AxesHelper";
            // panelAxesHelper.applyMatrix4(globalToLocal);
            this.panelGroupObj.add(panelAxesHelper)
        }

        // Use that transformation to calculate roof polygon points in 2D
        const polygonPoints2D = Util.convertPolygonPointsTo2D(polygonPoints, globalToLocal);
        // let roofPoints2D = Util.convertPolygonPointsTo2D(roofPoints, globalToLocal);
        const z_inverse = polygonPoints2D[0];
        // let roof2dptwithSetback = Util.setbackRoofPts(roofPoints2D, roofSetback, this.store, storeRoof);
        const roofSetbackPoints =(roofGeo.userData?.roofsetbackPts ? roofGeo.userData.roofsetbackPts : roofPoints);
        if (!roofSetbackPoints) {
            // this can typically happen in old roof before (Nov 19, 2023), If this happens test it by creating a new roof
            throw new Error("getValidPanelCorners: roof userdata doesn't have setback points");
        }
        const roof2dptwithSetback = Util.convertPolygonPointsTo2D(roofSetbackPoints, globalToLocal);
        roof2dptwithSetback.push(roof2dptwithSetback[0])
        const panelArea2dPtsWithSetback = (panelConfig.isDrawToFill) ? polygonPoints2D : roof2dptwithSetback;

        const panelArrayCorners = panelArea2dPtsWithSetback; // polygonPoints2D
        let localGutterStart = edgeLeftPoint; //.clone().applyMatrix4(globalToLocal);
        let localGutterEnd = edgeRightPoint; //.clone().applyMatrix4(globalToLocal);

        // Calculate bounding box for those roof points
        const bbox = Util.calculateBoundingBox(panelArrayCorners);

        if (panelConfig.isDrawToFill) {
            // if draw to fill, then setback is not necessary, but the gutter needs to be moved to the bbox.min

            const localGutterStart2D = edgeLeftPoint.clone().applyMatrix4(globalToLocal);
            const localGutterEnd2D = edgeRightPoint.clone().applyMatrix4(globalToLocal);

            const gutterToBboxMinVector = new Vector3();
            gutterToBboxMinVector.subVectors(bbox.min, localGutterStart2D)
            // gutterToBboxMinVector.normalize();
            // const gutterStartToBboxMindist = localGutterStart2D.distanceTo(bbox.min);

            // const moveGutterVector = gutterToBboxMinVector.clone().multiplyScalar(gutterStartToBboxMindist)
            localGutterStart = localGutterStart2D.clone().add(gutterToBboxMinVector);
            localGutterEnd = localGutterEnd2D.clone().add(gutterToBboxMinVector);


        } else {

            let gutterStartIndex = -1;
            let gutterEndIndex = -1;

            polygonPoints.forEach((pt, i) => {
                // comparing distance below becuase when scene is restored, the BufferGeometryUtils.mergeVertices doesn't give exactly same points

                if (pt.distanceTo(edgeLeftPoint) < 0.01) {
                    gutterStartIndex = i
                }

                if (pt.distanceTo(edgeRightPoint) < 0.01) {
                    gutterEndIndex = i
                }

            });
            if (gutterStartIndex == -1 || gutterEndIndex == -1) {
                throw new Error("Unable to identify gutter after setback");
            }
            const setbackGutterStart = panelArea2dPtsWithSetback[gutterStartIndex];
            const setbackGutterEnd = panelArea2dPtsWithSetback[gutterEndIndex];

            localGutterStart = setbackGutterStart; //.clone().applyMatrix4(globalToLocal);
            localGutterEnd = setbackGutterEnd; //.clone().applyMatrix4(globalToLocal);
        }


        // // Calculate polygon area
        // commenting this here, but this can be used to validate the area calculation during in store
        // const roofAreaZ = ShapeUtils.area(polygonPoints2D);
        // const roofArea = ShapeUtils.area(polygonPoints2D.map(pt => new Vector2(pt.x, pt.y)));
        // console.log({ roofAreaZ, roofArea });

        // Fit panels in the entire bounding box and store panel corners in pairs of four
        const projectedPanelFrameCorners = this.fitPanelsInBoundingBox(bbox, panelArrayCorners, localGutterStart, localGutterEnd, panelConfig);

        const allKeepOutPointsOnRoofResult = this.getAllKeepOutPointsOnRoof(storeRoof);
        const allKeepOutPointsOnRoof = Object.values(allKeepOutPointsOnRoofResult.keepouts);
        // Get 3D points to use for laying out panels in place of what we were getting from JSON file
        this.debugUtil.DebugPanelCalculations(this.panelGroupObj, projectedPanelFrameCorners, panelArrayCorners, allKeepOutPointsOnRoof)
        const validPanelFrameCorners = this.removePanelsOutsideRoof(projectedPanelFrameCorners, panelArrayCorners, roof2dptwithSetback);
        const globalProjectedPanelFrameCorners = this.convertToGlobal(validPanelFrameCorners, localToGlobal, z_inverse);

        return { globalProjectedPanelFrameCorners, globalToLocal, allKeepOutPointsOnRoof: allKeepOutPointsOnRoofResult };

    }

    getObstacleSetbackVertices(obstacles: Obstacle[]) {
        // Map over each obstacle to get setback vertices
        const vertices: Vector3[][] = obstacles.map(o => {
            // Fetch the setback mesh for the current obstacle
            const obstObj = this.engServ.scene.getObjectByName(o.id) as Mesh;
            if (obstObj?.parent) {
                // Get the setback mesh from the parent
                const setback = obstObj.parent?.getObjectByName(meshTypeEnum.obstacleSetbackMesh) as Mesh;
                if (setback) {
                    // Get the vertices of the setback mesh
                    const obstVerticesLength = Util.getMeshVertices(obstObj).length;
                    const obstOnRoofVectors = obstObj ? Util.getMeshVertices(setback, true) : [];
                    // Slice the vertices array in half
                    let firstHalf = obstOnRoofVectors;
                    if ((setback.geometry as any).parameters?.shapes?.holes?.length > 0 || (setback.geometry as any).parameters?.shapes[0]?.holes?.length > 0) {
                        firstHalf = obstOnRoofVectors.slice(0, -obstVerticesLength);
                        firstHalf.push(firstHalf[0])
                    }
                    return firstHalf;
                }
                return [];
            } else {
                return [];
            }
        })
        return vertices;
    }

    /**
     *
     * @returns an object containing keepouts (obstacles) and overlapping roofs separately for panel placements
     */
    getAllKeepOutPointsOnRoof(storeRoof: RoofSection, setback = true) {
        const roofObstacles = this.GetRoofStoreAssociatedObstacles(storeRoof.id);    
        const keepoutVertices: { [id: string]: Vector3[] } = {};
        const overlappingRoofVertices: { [id: string]: Mesh } = {};

        // Process obstacles in batch
        const obstacleVertices = this.GetObstacleVertices(roofObstacles);
        for (let i = 0; i < obstacleVertices.length; i++) {
            keepoutVertices[roofObstacles[i].id] = obstacleVertices[i];
        }

        if (setback) {
            const obstSetbackVertices = this.getObstacleSetbackVertices(roofObstacles);
            for (let i = 0; i < obstSetbackVertices.length; i++) {
                keepoutVertices[roofObstacles[i].id + "_setback"] = obstSetbackVertices[i];
            }
        }
        
        // Early exit if no overlapping roofs
        if (!storeRoof.overlappingRoofs?.length) {
            return { keepouts: keepoutVertices, overlappingRoofs: overlappingRoofVertices };
        }
        
        // Cache current roof data to avoid repeated lookups
        const currentRoofObj = this.engServ.scene.getObjectByName(storeRoof.id) as Object3D;
        if (!currentRoofObj) {
            return { keepouts: keepoutVertices, overlappingRoofs: overlappingRoofVertices };
        }
        
        const currentRoofPlane = currentRoofObj.getObjectByName(meshTypeEnum.roofPlane) as Mesh;
        const currentRoofHeight = this.getMinHeightVertexOfRoof(storeRoof.id);
        const currentRoofHeightFeet = Util.getMeasurementPixelToFeet(currentRoofHeight);
        const currentRoofPlaneGeometry = Util.getPlaneFromMesh(currentRoofPlane);
        
        // Process overlapping roofs
        for (const oRoofId of storeRoof.overlappingRoofs) {
            // Skip self-reference
            if (oRoofId === storeRoof.id) continue;
            
            const oRoofSection = this.GetStoreRoofSection(oRoofId);
            if (!oRoofSection) continue;
            
            const oRoofObj = this.engServ.scene.getObjectByName(oRoofId) as Object3D;
            if (!oRoofObj) continue;
            
            const oRoofPlane = oRoofObj.getObjectByName(meshTypeEnum.roofPlane) as Mesh;
            if (!oRoofPlane) continue;
            
            const overlappingRoofHeight = this.getMinHeightVertexOfRoof(oRoofId);
            const overlappingRoofHeightFeet = Util.getMeasurementPixelToFeet(overlappingRoofHeight);
            const rawHeightDifference = overlappingRoofHeightFeet - currentRoofHeightFeet;
            
            
            // Check height and coplanar conditions
            const absHeightDiff = Math.abs(rawHeightDifference);
            if (absHeightDiff <= 0.5 && rawHeightDifference >= 0) {
                // Check if roofs are coplanar by comparing normals
                const overlappingRoofPlaneGeometry = Util.getPlaneFromMesh(oRoofPlane);
                const normalDot = Math.abs(currentRoofPlaneGeometry.normal.dot(overlappingRoofPlaneGeometry.normal));
                const isCoplanar = normalDot > 0.99; // Allow small tolerance for floating point precision
                
                if (isCoplanar) {
                    // Add overlapping roof vertices as keepout vertices since they're at same height and coplanar
                    keepoutVertices[oRoofId] = Util.getMeshVertices(oRoofPlane, true);
                } else {
                    // Different orientation, treat as overlapping roof
                    overlappingRoofVertices[oRoofId] = oRoofPlane;
                }
            } else {
                // Significant height difference, treat as overlapping roof
                overlappingRoofVertices[oRoofId] = oRoofPlane;
            }
        }        
        return { keepouts: keepoutVertices, overlappingRoofs: overlappingRoofVertices };
    }

    /**
     * return all visible panel instances points
     * @param instancedMesh
     * @returns
     */
    getAllPanelPoints(instancedMesh: InstancedMesh, allPanels: boolean = false) : {[key: string]: Vector3[]}{
        if (!instancedMesh || !instancedMesh.parent) {
            return {};
        }
        const panelArrayId = instancedMesh.parent.name;
        let panelConfig: PanelArray | undefined;
        this.store.select(fromPanelArraySelectors.selectPanelArraysByIds([panelArrayId])).pipe(take(1)).subscribe(arrayy => {
            if (arrayy.length <= 0) return;
            panelConfig = arrayy[0]!;
        })
        if(!panelConfig) return {};
        const visibilityArray = InstancedMeshUtil.getVisibilityArray(instancedMesh);

        const panelPoints : {[key: string]: Vector3[]}= {};
        for (let i = 0; i < instancedMesh.count; i++) {
          const isVisibleInstance = allPanels || visibilityArray[i] ==1;
            if(isVisibleInstance){
              const panelGeom = new PlaneGeometry(Util.getMeasurementFeetToPixel(panelConfig.panelWidth), Util.getMeasurementFeetToPixel(panelConfig.panelLength));
              const matrix = new Matrix4();
              instancedMesh.getMatrixAt(i, matrix);
              panelGeom.applyMatrix4(matrix);
               const vertices =  Util.getGeometryVertices(panelGeom);
               [vertices[2], vertices[3]] = [vertices[3], vertices[2]]
                panelPoints[''+i.toString()]=vertices;
            }
        }
        return panelPoints;
    }

    getMaxHeightVertexOfRoof(name:string){
        const roofPlane = (this.engServ.scene.getObjectByName(name) as Object3D).getObjectByName(meshTypeEnum.roofPlane) as Mesh;
        const vertices = Util.getMeshVertices(roofPlane, true);
        let max = 0;
        vertices.forEach((v,i)=>{
            if(v.z > max){
                max = v.z;
            }
        })
        return max;
    }

    getMinHeightVertexOfRoof(name: string) {
        const roofPlane = (this.engServ.scene.getObjectByName(name) as Object3D).getObjectByName(meshTypeEnum.roofPlane) as Mesh;
        const vertices = Util.getMeshVertices(roofPlane, true);
        let min = Infinity;
        vertices.forEach((v, i) => {
            if (v.z < min) {
                min = v.z;
            }
        })
        return min;
    }

    fitPanelsInBoundingBox(bbox: Box3, panelArrayCorners: Vector3[], gutterStartPoint: Vector3, gutterEndPoint: Vector3, panelConfig: PanelArray) {

        // const gap = panelDims.GAP;
        const isLandscape = (panelConfig.orientation === PanelOrientation.landscape);
        const alignType = panelConfig.alignment;
        const isEastWest = panelConfig.arrayType === '2';

        const panelWidthPx =Util.getMeasurementFeetToPixel(panelConfig.panelWidth) ;  // panelDims.WIDTH;
        const panelLengthPx = Util.getMeasurementFeetToPixel(panelConfig.panelLength);  // panelDims.LENGTH;
        const frameSpace = Util.getMeasurementFeetToPixel(panelConfig.frameSpace);
        const clampSpace = Util.getMeasurementFeetToPixel(panelConfig.clampSpace);
        const peakSpace = Util.getMeasurementFeetToPixel(panelConfig.peakSpace);

        const orientedFrameWidthPx = (isLandscape ? panelConfig.noOfColumns * panelLengthPx : panelConfig.noOfColumns * panelWidthPx) + (panelConfig.noOfColumns - 1) * (clampSpace + Util.getMeasurementFeetToPixel(constants.PanlePlacementOffset)); // this is the horizontal dimension
        const orientedFrameLengthPx = (isLandscape ? panelConfig.noOfRows * panelWidthPx : panelConfig.noOfRows * panelLengthPx) + (panelConfig.noOfRows - 1) * (clampSpace + Util.getMeasurementFeetToPixel(constants.PanlePlacementOffset)); // this is the vertical dimension

        const bboxMinGutterXDiffStart = bbox.min.x - gutterStartPoint.x;
        // const bboxMinGutterXDiffEnd = bbox.min.x - gutterEndPoint.x;

        // const bboxMinGutterDiff = Math.max(bboxMinGutterXDiffEnd, bboxMinGutterXDiffStart);
        if (bboxMinGutterXDiffStart < 0) {
            // if bbox min point is before the gutter point, then expand bbox min so that the gutterStart coincides with a panel's bottom left corner as starting point
            // this ensures that the first row of the panels is always included
            const remainderDistance = Math.abs(bboxMinGutterXDiffStart % orientedFrameWidthPx);
            bbox.min.x -= remainderDistance;
        }

        /**
        when a panel is tilted and inter-row spacing is 0, then gap between panels from top view should be 0
        * @param {number} projectedPanelFrameLength - the projected length of a tilted panel on the ground/roof.
        */
        const projectedPanelFrameLength = orientedFrameLengthPx * Math.cos(MathUtils.degToRad(panelConfig.panelTilt));

        let rowHeight = 0;
        if (isEastWest) {
            rowHeight = 2 * projectedPanelFrameLength + (Util.getMeasurementFeetToPixel(panelConfig.interrowspacing!) ?? 0) + peakSpace;
        } else {
            rowHeight = projectedPanelFrameLength + (Util.getMeasurementFeetToPixel(panelConfig.interrowspacing!) ?? 0);

        }
        const xIncr = orientedFrameWidthPx + frameSpace + Util.getMeasurementFeetToPixel(constants.PanlePlacementOffset) ; // + gap;
        const yIncr = rowHeight + Util.getMeasurementFeetToPixel(constants.PanlePlacementOffset); // + gap;

        if (xIncr <= 0 || yIncr <= 0) throw new Error("incorrect panelWidth or panelHeight");


        // // LOGIC to calculate panel based on alignment
        const bottomLineStart = gutterStartPoint.clone().setX(bbox.min.x);
        const bottomLineEnd = gutterEndPoint.clone().setX(bbox.max.x);

        const gutterToBboxDir = new Vector3();
        gutterToBboxDir.subVectors(bbox.min.clone().setZ(0), bottomLineStart.clone().setZ(0));

        // if the gutter start point and bbox min point are not the same, then move the gutter to start at bbob min
        bottomLineStart.add(gutterToBboxDir);
        bottomLineEnd.add(gutterToBboxDir);

        // extend the bottom line by 5 units to make sure it covers all the polygon
        bottomLineStart.x -= 5;
        bottomLineEnd.x += 5;

        //Commenting this code below because of ENV-6294

        // const { minPt, minPt2 } = Util.getBottom2Points(panelArrayCorners, "y");

        // if (minPt2) {
        //     // if minPt & minPt2 of panel array bounderies are in different y positions, it means the bottom line is not straight. So None of the bottom row panel will be valid.
        //     // So its better to move the "Y" of bottom start point to the minPt2.y

        //     bottomLineStart.setY(minPt2.y);
        //     bottomLineEnd.setY(minPt2.y);
        // }

        const bottomline = [bottomLineStart, bottomLineEnd];
        let firstRowStart = undefined;

        const inset = constants.DefaultEdgeThickness; // 0.1; // offset start so that the first row always is inside the panelArray boundary
        const yStart = bottomLineStart.y + inset;
        const yEnd = bbox.max.y - yIncr + Util.getMeasurementFeetToPixel(panelConfig.interrowspacing!); // - inset;
        const projectedPanelCorners: Vector3[][] = [];

        for (let y = yStart; y < yEnd; y += yIncr) {
            const currRowTopLine = bottomline.map(pt => {
                pt.y = y;
                return pt.clone().setY(pt.y + projectedPanelFrameLength);
            });

            const topIntersectPts = this.checkRowIntersectionPts(panelArrayCorners, currRowTopLine);
            const bottomIntersectPts = this.checkRowIntersectionPts(panelArrayCorners, bottomline);

            const usableRowStartPt = topIntersectPts.minPt.x < bottomIntersectPts.minPt.x ? bottomIntersectPts.minPt : topIntersectPts.minPt;
            const usableRowEndPt = topIntersectPts.maxPt.x < bottomIntersectPts.maxPt.x ? topIntersectPts.maxPt : bottomIntersectPts.maxPt;

            usableRowStartPt.x += inset;
            usableRowEndPt.x -= inset;

            const usableRowDist = Math.abs(usableRowEndPt.x - usableRowStartPt.x);
            // usableRowDist = usableRowDist; // - (2 * inset); // the thickness of edges need to be removed from the total distance

            if (usableRowStartPt.x > usableRowEndPt.x || usableRowDist < orientedFrameWidthPx) {
                // if row width is less than panel width
                continue;
            }

            const remainderDistance = (usableRowDist % (orientedFrameWidthPx+frameSpace + Util.getMeasurementFeetToPixel(constants.PanlePlacementOffset)))%orientedFrameWidthPx + frameSpace;
            // let validRowDistance = usableRowDist - remainderDistance;

            // this is used to offset x starting point slightly so the first panel is always inside polygon;
            // this is useful because sometimes, the calulcation to check point in polygon is not 100% accurate;
            let xStartOffset = 0;

            switch (alignType) {
                case ArrayAlignment.left:
                    xStartOffset = 0.0000001;
                    break;

                case ArrayAlignment.right:
                    xStartOffset = remainderDistance - 0.0000001;
                    break;

                case ArrayAlignment.center:
                    // center alignment
                    xStartOffset = (remainderDistance / 2); // - 0.0000001;
                    break;

                case ArrayAlignment.justify:
                    // justify alignment
                    if (firstRowStart) {
                        // from 2nd row, caluclate the difference between first row start and curr row start and move curr starting pointt by the remainder
                        const currRowToFirstRowDiff = firstRowStart.x - usableRowStartPt.x;
                        const remainderJustify = currRowToFirstRowDiff % (orientedFrameWidthPx + Util.getMeasurementFeetToPixel(constants.PanlePlacementOffset));

                        xStartOffset = remainderJustify + 0.0000001;

                    } else {
                        firstRowStart = usableRowStartPt;
                        xStartOffset = 0.0000001;
                    }
                    break;

                default:
                    break;
            }

            const xStart = usableRowStartPt.x + xStartOffset; // + inset;
            const xEnd = usableRowEndPt.x - xIncr + frameSpace; // - inset;
            for (let x = xStart; x < xEnd; x += xIncr) {
                const panelPts = [
                    new Vector3(x, y, 0),
                    new Vector3(x + orientedFrameWidthPx, y, 0),
                    new Vector3(x + orientedFrameWidthPx, y + (isEastWest ? (2 * projectedPanelFrameLength + peakSpace) : projectedPanelFrameLength), 0),
                    new Vector3(x, y + (isEastWest ? (2 * projectedPanelFrameLength + peakSpace) : projectedPanelFrameLength), 0),
                ];

                projectedPanelCorners.push(panelPts);
            }

        }
        return projectedPanelCorners;
    }

    checkRowIntersectionPts(polygonPointsArray: Vector3[], gutter: Vector3[]) {
        const allIntersectionPts: Vector3[] = [];

        let max = -Infinity;
        let min = Infinity;
        let maxPt: Vector3 | undefined, minPt: Vector3 | undefined;
        polygonPointsArray.map((pt, i) => {
            const polygonLineStart = pt;
            const polygonLineEnd = i + 1 > polygonPointsArray.length - 1 ? polygonPointsArray[0] : polygonPointsArray[i + 1];

            const gutterStart = gutter[0];
            const gutterEnd = gutter[1];

            const intersect = CollisionUtil.intersectLines([polygonLineStart, polygonLineEnd], [gutterStart, gutterEnd])

            if (intersect) {
                allIntersectionPts.push(intersect);

                if (intersect.x > max) {
                    // if more than 2 intersections, then identify max Pt
                    maxPt = intersect;
                    max = intersect.x;
                }

                if (intersect.x < min) {
                    // if more than 2 intersections, then identify min Pt
                    minPt = intersect;
                    min = intersect.x;
                }
            }

        });

        if (!maxPt || !minPt) {
            throw new Error("Unable to intersect ");

        }

        // all intersection points could have more than 3 if the polygon has a concave shape
        return { minPt, maxPt };
    }

  removePanelsOutsideRoof(panelCorners: Vector3[][], polygonPoints: Vector3[], roof2dptwithSetback: Vector3[]) {
    const validPanelCorners: Vector3[][] = panelCorners.filter((panelPts, i) => {
      panelPts.push(panelPts[0]);
      const a = CollisionUtil.isPolygonInside(polygonPoints, panelPts);
      const b = CollisionUtil.isPolygonInside(roof2dptwithSetback, panelPts);
      return (a && b );
    });

    return validPanelCorners;
  }
    /**
     * @param panelConfig panel array configuration
     * @param panelInstancedMesh the instanced mesh containing panels
     * @param keepoutPoints obstacle vertices for collision detection
     * @param overlappingRoofPoints overlapping roof vertices for collision detection
     * @returns array of invisible panel indices due to collisions with obstacles or overlapping roofs
     */
    invisiblePanelsOverlappingWithObstacles(panelConfig: PanelArray, panelInstancedMesh:InstancedMesh, keepoutPoints: Vector3[][], overlappingRoofPoints: { [id: string]: Mesh } = {}) {
      const invisibleIndices: number[] = [];
      const visibleIndices: number[] = [];

      // Capture current visibility BEFORE making any changes.
      // Panels that are currently visible (e.g., moved panels) should be
      // prioritized over panels that were hidden (e.g., under old setback).
      const previouslyVisible = new Set<number>();
      for (let i = 0; i < panelInstancedMesh.count; i++) {
        if (InstancedMeshUtil.getVisibilityAt(panelInstancedMesh, i)) {
          previouslyVisible.add(i);
        }
      }

      for (let i = 0; i < panelInstancedMesh.count; i++) {
        const mat = new Matrix4();
        panelInstancedMesh.getMatrixAt(i, mat);
        const panelGeom = new PlaneGeometry(
          Util.getMeasurementFeetToPixel(panelConfig.panelWidth),
          Util.getMeasurementFeetToPixel(panelConfig.panelLength)
        );
        panelGeom.applyMatrix4(mat);
        
        // Check collision with obstacles
        const isCollidedWithKeepouts = this.checkPanelCollisionWithKeepout(
          panelGeom,
          keepoutPoints
        );
        
        // Check collision with overlapping roofs
        const isCollidedWithOverlappingRoofs = this.checkRoofonRoofCollision(
          panelGeom,
          overlappingRoofPoints
        );
        
        if (isCollidedWithKeepouts || isCollidedWithOverlappingRoofs) {
          invisibleIndices.push(i);
        } else {
          visibleIndices.push(i);
        }
      }

      // Detect panel-on-panel geometric overlap among visible panels.
      // When a panel is manually placed or moved onto the obstacle setback area
      // and then the setback is decreased, previously-hidden panels may try to
      // reappear at positions that overlap with the placed/moved panel.
      // Uses full geometric collision (AABB + vertex-in-polygon + edge intersection)
      // to reliably detect overlap regardless of exact panel positions.
      //
      // Skip this check for east-west arrays: east and west facing panels share
      // a common boundary at the peak (especially when peakSpace is 0) and the
      // boundary-inclusive collision check would incorrectly mark west panels as
      // overlapping with east panels, hiding them.
      //
      // Sort visible indices so that previously-visible panels (moved/placed panels)
      // come first. This ensures they are "accepted" first, and any ghost panels
      // that were hidden under the old setback are detected as duplicates.
      const isEastWest = panelConfig.arrayType === '2';
      const sortedVisibleIndices = [...visibleIndices].sort((a, b) => {
        const aWasVisible = previouslyVisible.has(a) ? 0 : 1;
        const bWasVisible = previouslyVisible.has(b) ? 0 : 1;
        return aWasVisible - bWasVisible;
      });

      const acceptedPanelVertices: Vector3[][] = [];
      const overlapIndices: number[] = [];

      if (!isEastWest) {
        for (const idx of sortedVisibleIndices) {
          const mat = new Matrix4();
          panelInstancedMesh.getMatrixAt(idx, mat);
          const panelOverlapGeom = new PlaneGeometry(
            Util.getMeasurementFeetToPixel(panelConfig.panelWidth),
            Util.getMeasurementFeetToPixel(panelConfig.panelLength)
          );
          panelOverlapGeom.applyMatrix4(mat);

          if (acceptedPanelVertices.length > 0 && this.checkPanelCollisionWithKeepout(panelOverlapGeom, acceptedPanelVertices)) {
            overlapIndices.push(idx);
          } else {
            const vertices = Util.getGeometryVertices(panelOverlapGeom);
            [vertices[2], vertices[3]] = [vertices[3], vertices[2]];
            acceptedPanelVertices.push(vertices);
          }
        }
      }

      if (overlapIndices.length > 0) {
        const finalVisibleIndices = visibleIndices.filter(i => !overlapIndices.includes(i));
        invisibleIndices.push(...overlapIndices);
        InstancedMeshUtil.setMultipleVisibilities(panelInstancedMesh, invisibleIndices, false);
        InstancedMeshUtil.setMultipleVisibilities(panelInstancedMesh, finalVisibleIndices, true);
      } else {
        InstancedMeshUtil.setMultipleVisibilities(panelInstancedMesh, invisibleIndices, false);
        InstancedMeshUtil.setMultipleVisibilities(panelInstancedMesh, visibleIndices, true);
      }
        
        // sync store visibility after scene visibility changes
        this.syncStoreVisibilityWithSceneAsync(panelInstancedMesh, panelConfig)
            .catch(error => console.error('Error syncing visibility after obstacle collision detection:', error));
        
      return invisibleIndices;

    }
    /**
     *
     * @param panel
     * @param keepoutPoints
     * @returns whether the panel collides with the keepouts
     */
       checkPanelCollisionWithKeepout(panel: BufferGeometry, keepoutPoints: Vector3[][]): boolean {
        const panelVertices = Util.getGeometryVertices(panel);
        [panelVertices[2], panelVertices[3]] = [panelVertices[3], panelVertices[2]];
    
        if (keepoutPoints.length <= 0) return false;
    
        // Calculate AABB for the panel
        const panelAABB = this.calculateAABB(panelVertices);
    
        for (const keepOut of keepoutPoints) {
            // Calculate AABB for the keepout polygon
            const keepoutAABB = this.calculateAABB(keepOut);
    
            // Check if AABBs intersect
            if (!this.aabbIntersect(keepoutAABB, panelAABB)) {
                continue;
            }
    
            // Combined loop for checking vertices inside polygons and edge intersections
            for (let i = 0; i < panelVertices.length; i++) {
                const panelVertex = panelVertices[i];
                const nextPanelVertex = panelVertices[(i + 1) % panelVertices.length];
                const panelEdgePts = [panelVertex, nextPanelVertex];

                // Check if any panel vertex is inside the keepout polygon
                if (CollisionUtil.isPointInPolygon(keepOut, panelVertex, true)) {
                    return true;
                }

                for (let k = 0; k < keepOut.length; k++) {
                    const keepoutVertex = keepOut[k];
                    const nextKeepoutVertex = keepOut[(k + 1) % keepOut.length];
                    const keepoutEdgePts = [keepoutVertex, nextKeepoutVertex];

                    // Check if any keepout vertex is inside the panel polygon
                    if (CollisionUtil.isPointInPolygon(panelVertices, keepoutVertex, true)) {
                        return true;
                    }

                    // Check for edge intersections
                    if (CollisionUtil.intersectLines(panelEdgePts, keepoutEdgePts)) {
                        return true;
                    }
                }
            }
        }
    
        return false;
    }
     /**
     *
     * @param panel
     * @param keepoutPoints
     * @returns whether the panel collides with the keepouts
     */
    checkRoofonRoofCollision(panel: BufferGeometry, keepoutMeshes: { [id: string]: Mesh }): boolean {
        // Convert mesh objects to array of Vector3[]
        const keepoutPoints: Vector3[][] = Object.values(keepoutMeshes).map(mesh => Util.getMeshVertices(mesh, true));
        const panelVertices = Util.getGeometryVertices(panel);
        [panelVertices[2], panelVertices[3]] = [panelVertices[3], panelVertices[2]];

        if (keepoutPoints.length <= 0) return false;

        // Calculate AABB for the panel
        const panelAABB = this.calculateAABB(panelVertices);

        const keepoutMeshList = Object.values(keepoutMeshes);

        for (let idx = 0; idx < keepoutPoints.length; idx++) {
            const keepOut = keepoutPoints[idx];
            const keepoutAABB = this.calculateAABB(keepOut);

            // Check if AABBs intersect
            if (!this.aabbIntersect(keepoutAABB, panelAABB)) {
                continue;
            }

            // Use the plane from the keepout mesh directly
            const keepOutMesh = keepoutMeshList[idx];
            const originalPlane = Util.getPlaneFromMesh(keepOutMesh);
            const keepOutPlane = originalPlane.clone();

            // Ensure the plane normal is upwards (z > 0)
            if (keepOutPlane.normal.z < 0) {
                keepOutPlane.normal.negate();
                keepOutPlane.constant = -keepOutPlane.constant;
            }

            // Fast check: If all panel vertices are outside keepout polygon, skip further checks
            let panelInsideKeepout = false;
            for (const vertex of panelVertices) {
                if (CollisionUtil.isPointInPolygon(keepOut, vertex, true)) {
                    panelInsideKeepout = true;
                    break;
                }
            }
            
            // This handles cases where roof corners/vertices are over panels
            for (const roofVertex of keepOut) {
                if (CollisionUtil.isPointInPolygon(panelVertices, roofVertex, true)) {
                    panelInsideKeepout = true;
                    break;
                }
            }
            if (!panelInsideKeepout) continue;

            // Only check plane distance if panel is inside polygon
            if (panelVertices.some(point => keepOutPlane.distanceToPoint(point) <= 0)) {
                return true;
            }

        }

        return false;
    }
    
    
    calculateAABB(points: Vector3[]): Box3 {
        const bbox = new Box3();
    
        for (const point of points) {
            bbox.expandByPoint(point);
        }
    
        return bbox;
    }
    
    aabbIntersect(aabb1: { min: Vector3, max: Vector3 }, aabb2: { min: Vector3, max: Vector3 }): boolean {
        return (
            aabb1.min.x <= aabb2.max.x && aabb1.max.x >= aabb2.min.x &&
            aabb1.min.y <= aabb2.max.y && aabb1.max.y >= aabb2.min.y
            // && aabb1.min.z <= aabb2.max.z && aabb1.max.z >= aabb2.min.z
        );
    }

    convertToGlobal(validPanelCorners: Vector3[][], localToGlobalMatrix: Matrix4, z_inverse: Vector3) {
        const validPanelCorners3D: Vector3[][] = []

        validPanelCorners.forEach(panel => {
            const globalPanelPts = panel.map(panelPt => {
                const point = panelPt.clone();
                point.add(new Vector3(0, 0, z_inverse.z + 0.1));
                //let validPanelCorner3D = point

                return point.applyMatrix4(localToGlobalMatrix);
            });

            validPanelCorners3D.push(globalPanelPts);
        });
        return validPanelCorners3D;
    }


    convertPanelsToLocal(globalPanelCorners: Vector3[][], globalToLocalMatrix: Matrix4, z_inverse: Vector3) {
        const localPanelCorners: Vector3[][] = []

        globalPanelCorners.forEach(panel => {
            const globalPanelPts = panel.map(panelPt => {
                const point = panelPt.clone();
                point.applyMatrix4(globalToLocalMatrix);
                point.sub(new Vector3(0, 0, z_inverse.z + 0.1));
                //let validPanelCorner3D = point

                return point;
            });

            localPanelCorners.push(globalPanelPts);
        });
        return localPanelCorners;
    }

    createVertex(type: number): Mesh {
        const sphereGeo = new SphereGeometry(6.4, 16, 8);
        const boxGeo = new BoxGeometry(10, 10, 10);
        const material = new MeshPhysicalMaterial({
            color: type == vertexType.spherical ? threeColors.finalVertex : threeColors.tempVertex,
            side: DoubleSide,
            transparent: true,
            opacity: 0.5,
        });

        const geometry = type == vertexType.spherical ? sphereGeo : boxGeo;
        const vertex = new Mesh(geometry, material);
        vertex.name = type == vertexType.spherical ? "RoofVertex" : "tempVertex";
        return vertex;
    }


    tiltPanelFrame(frameGroup: Mesh[], framePts: Vector3[], panelTiltDeg: number = 0, gutterVector: Vector3, isEastWest:boolean) {
        if (panelTiltDeg == 0) return framePts;

        const panelFrameRotationAxisVector = Util.GetVectorByPoints(framePts[0], framePts[1]);
        const panelFrameBottomPt = framePts[0];
        const panelFrameTopPt = framePts[3];
        let tiltAngleRad = Util.convertDegreeToRadian(panelTiltDeg);
        const panelAngleWithGutter = panelFrameRotationAxisVector.angleTo(gutterVector);
        if (panelAngleWithGutter == Math.PI) {
            tiltAngleRad = -tiltAngleRad;
        }
        frameGroup.forEach((panel, i) => {
            if (isEastWest) {
                if (i < frameGroup.length / 2) {
                  Util.rotateAroundWorldAxis(panel, panelFrameBottomPt, panelFrameRotationAxisVector, tiltAngleRad);
                }else{
                   Util.rotateAroundWorldAxis(panel, panelFrameTopPt, panelFrameRotationAxisVector, -tiltAngleRad);
                }
            } else {
              Util.rotateAroundWorldAxis(panel, panelFrameBottomPt, panelFrameRotationAxisVector, tiltAngleRad);
            }
        });
        const tiltedFramePoints = Util.rotatePointsAroundAxis(framePts,  panelFrameRotationAxisVector, tiltAngleRad, panelFrameBottomPt);
        return tiltedFramePoints;
    }

    getPanelBottomAxis(pts: Vector3[]) {

        const { minPt, minPt2 } = Util.getBottom2Points(pts);

        if (minPt2 && minPt) {
            const axisVector = new Vector3(minPt2.x - minPt.x, minPt2.y - minPt.y, minPt2.z - minPt.z);
            return { axisVector, minPt };
        } else {
            throw new Error("Unable to find axis of rotation of the panel");
        }
    }

    GetRoofStoreAssociatedObstacles(roofId: string) {
        const obstacles: Obstacle[] = [];
        this.store
            .select(fromObstacleSelectors.selectObstaclesByAssociatedRoofId(roofId))
            .pipe(take(1))
            .subscribe((storeObs) => {
                storeObs.map(o => {
                    o = JSON.parse(JSON.stringify(o));
                    if (o !== undefined) {
                        o.height = Util.getMeasurementFeetToPixel(o.height);
                        o.length = Util.getMeasurementFeetToPixel(o.length);
                        o.width = Util.getMeasurementFeetToPixel(o.width);
                        o.diameter = Util.getMeasurementFeetToPixel(o.diameter ? o.diameter : 0);
                        obstacles.push(o);
                    }
                })
            })

        // Rooftop Storage/Inverter components act as panel keep-outs, exactly
        // like a rectangle obstacle. Their footprint mesh is named with the
        // component id so GetObstacleVertices() reads it the same way.
        this.store
            .select(fromDesignComponentSelectors.selectDesignComponentsByAssociatedRoofId(roofId))
            .pipe(take(1))
            .subscribe((components) => {
                components.forEach((c) => {
                    if (!c || c.mountingType !== MountingType.rooftop) return;
                    const pseudo = {
                        id: c.id,
                        roofId: c.roofId,
                        roofAssociation: c.roofAssociation,
                        type: ObstacleType.rectangle,
                        height: Util.getMeasurementFeetToPixel(c.height),
                        length: Util.getMeasurementFeetToPixel(c.length),
                        width: Util.getMeasurementFeetToPixel(c.width),
                        diameter: 0,
                        rotation: c.rotation,
                        vertexIds: [],
                    } as unknown as Obstacle;
                    obstacles.push(pseudo);
                });
            });

        return obstacles;
    }

    GetStoreRoofSection(roofId: string) {
        let roofSection!: RoofSection | undefined
        this.store
            .select(fromRoofSectionSelectors.selectRoofById([roofId]))
            .pipe(take(1))
            .subscribe((roofs) => {
                roofSection = roofs[0]
            })

        return roofSection
    }

    getStorePanelArray(roofId: string){
        let panelArray!: PanelArray
        this.store.select(fromPanelArraySelectors.selectPanelArraysByRoofId(roofId))
                .pipe(take(1))
                .subscribe(roofPanelArrays => {
                    panelArray = roofPanelArrays[0]
                })
                return panelArray
    }

    GetPanelArrayBoundaryVertices(panelArray: PanelArray) {
        let vertices: Vector3[] = []
        this.store
            .select(fromVertexSelectors.selectVerticesByIds(panelArray.vertices ?? []))
            .pipe(take(1))
            .subscribe((verts) => {
                vertices = verts.map(v => new Vector3(v.x, v.y, v.z));
            })

        return vertices
    }
    GetObstacleVertices(obstacles: Obstacle[]) {
        const vertices: Vector3[][] = obstacles.map(o => {
            // let vectors: Vector3[] = [];

            // const obstRoof = this.engServ.scene.getObjectByName(o.roofId);
            // const roofPlane = (obstRoof?.userData as MeshUserData).roofConfirmedPlane
            const obstRootObj = this.engServ.scene.getObjectByName(o.id) as Mesh;
            // const obstMeshOnRoof = obstRootObj?.parent?.getObjectByName(meshTypeEnum.obstMeshFlushedOnRoof) as Mesh;

            // if (obstRootObj) {
            const ObstOnRoofVectors = obstRootObj ? Util.getMeshVertices(obstRootObj, true) : [];
            // }

            if (o.type == ObstacleType.rectangle || o.type == ObstacleType.walkways) {
                // swap 3rd and 4th vertices to make them clockwise
                // this is necessary to check if panel pt is in obstacle
                // https://stackoverflow.com/questions/22521982/check-if-point-is-inside-a-polygon/29915728#comment135270782_29915728
                const temp = ObstOnRoofVectors[2];
                ObstOnRoofVectors[2] = ObstOnRoofVectors[3];
                ObstOnRoofVectors[3] = temp;

            }


            // // commenting below coed because if the obstacle has height, then the vertices are not exactly on roof - which might cause issues
            // const vertexIds = o.vertexIds;
            // const obstHeight = Util.getMeasurementFeetToPixel(o.height);
            // this.store
            //     .select(fromVertexSelectors.selectVerticesByIds(vertexIds))
            //     .pipe(take(1))
            //     .subscribe((storeVerts) => {
            //         if (o.type == ObstacleType.circle) {
            //             const center = new Vector3(storeVerts[0].x, storeVerts[0].y, storeVerts[0].z);
            //             const circleBbox = new PlaneGeometry(o.diameter, o.diameter);
            //             var mat = new MeshBasicMaterial({ color: 0xff0000 });
            //             var circleBboxMesh = new Mesh(circleBbox, mat);
            //             circleBboxMesh.position.copy(center);

            //             circleBboxMesh.updateMatrix();
            //             const matrix = circleBboxMesh.matrix;
            //             const positionsBuffer = circleBboxMesh.geometry.getAttribute('position') as BufferAttribute;
            //             for (let i = 0; i < positionsBuffer.array.length / 3; i++) {
            //                 const point = new Vector3().fromBufferAttribute(positionsBuffer, i);
            //                 const vertMesh = Util.createVertex(vertexType.spherical);
            //                 vertMesh.name = Util.generateStoreId('vertex');
            //                 vertMesh.position.copy(point);

            //                 let worldPt = point.clone();
            //                 // worldPt.z -= obstHeight;
            //                 // if (roofPlane) {
            //                 // // projectPointOnPlane below is not working as expected
            //                 //     worldPt = Util.projectPointOnPlane(worldPt.clone(), roofPlane);
            //                 // }
            //                 worldPt.applyMatrix4(matrix);
            //                 vectors.push(worldPt)
            //             }
            //         } else {
            //             storeVerts.map(v => {
            //                 let pt = new Vector3(v.x, v.y, v.z - obstHeight);
            //                 // if (roofPlane) {
            //                 // // projectPointOnPlane below is not working as expected
            //                 //     pt = Util.projectPointOnPlane(pt.clone(), roofPlane);
            //                 // }
            //                 vectors.push(pt);
            //             })
            //         }

            //     })

            return ObstOnRoofVectors;  // vectors;
        })

        return vertices;

    }

    calculateInterRowSpacing(panelConfig: PanelArray, roofTilt: number) {
        let interrowspacing = 0;
        let panelTilt = panelConfig.panelTilt;
        if(panelConfig.arrayType == '2'){ //TODO: Change it to eastwest
            return this.defaultInterRowSpace;
        }
        if (panelTilt <= 0) {
            panelTilt = 0;
            interrowspacing = 0;
        } else if (panelTilt > 0) {
            const panelWidth = panelConfig.panelWidth;
            const panelLength = panelConfig.panelLength;

            const isLandscape = (panelConfig.orientation == PanelOrientation.landscape);

            let sumVal = 0;
            const totDegrees = 90;
            sumVal = Number(panelTilt) + Number(roofTilt);

            // ---- Calculate heightDiff based on panel Tilt ----
            let heightDiff = isLandscape ?panelConfig.noOfRows * panelWidth : panelConfig.noOfRows * panelLength; // default row height is the same as panel - if tilt is 0;

            // If panel is tilted, then the gap between the rows can be less than the panel height/width

            panelTilt = (sumVal <= 90) ? panelTilt : (totDegrees - roofTilt);
            panelTilt = MathUtils.degToRad(panelTilt);
            heightDiff = Math.sin(panelTilt) * (isLandscape ? panelConfig.noOfRows * panelWidth : panelConfig.noOfRows * panelLength);

            // ---- Use heightDiff to calculate min rowspacing so there's not shadow overlap using solarTilt ----
            let solarTiltAngel, panelRowHeight;
            let locale = this.authService.getItem('localeId', 'localStorage');
            if (!locale) {
                locale = 'en_US';
            }
            solarTiltAngel = this.localeToSolarTiltAngelObj[locale];
            if (!solarTiltAngel) {
                solarTiltAngel = 16;
            }
            //To add clamp space
            heightDiff = heightDiff + ((panelConfig.noOfRows - 1) * panelConfig.clampSpace);
            // heightDiff = heightDiff + (panelConfig.noOfRows == 1 ? panelConfig.noOfRows * panelConfig.clampSpace : (panelConfig.noOfRows - 1) * panelConfig.frameSpace);

            solarTiltAngel = Number(solarTiltAngel);
            solarTiltAngel = MathUtils.degToRad(solarTiltAngel);
            panelRowHeight = Math.abs(heightDiff / Math.tan(solarTiltAngel));
            interrowspacing = panelRowHeight - heightDiff;
        }
        return Util.getMeasurementPixelToFeet(interrowspacing);

    }

    getLocaleToSolarTiltAngels(): Subscription {
        return this.panelconfigService.getLocaleToTiltAngels().subscribe(
            (response) => {
                this.localeToSolarTiltAngelObj = response;
            },
            (error) => {
                console.log(
                    'Something went wrong while fetching locale to tilt angels list'
                );
            }
        )
    }

    changeCursor(intersects: Intersection[], isSinglePanelMode: boolean = false) {
        const nearestIntersect = intersects[0]?.object;
        
        if (!nearestIntersect) {
            this.cursorState = PanelArrayCursors.INVALIDPANELARRAYADD;
            this.engServ.updatePanelArrayCursorState(this.cursorState);
            return;
        }

        this.cursorState = PanelArrayCursors.NORMALPANEL;
        const namePrefix = nearestIntersect.name.split('-').shift();
        
        if (isSinglePanelMode) {
            switch (namePrefix) {
                case meshTypeEnum.roofPlane:
                case meshTypeEnum.roofSetbackMesh:
                    if (nearestIntersect.parent?.name) {
                        const panelInstancedMesh = nearestIntersect.parent?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
                        this.cursorState = panelInstancedMesh ? PanelArrayCursors.VALIDSINGLEPANELADD : PanelArrayCursors.INVALIDSINGLEPANELADD;
                    }else{
                        this.cursorState = PanelArrayCursors.INVALIDSINGLEPANELADD;
                    }
                    break;
                case meshTypeEnum.panelArray:
                case meshTypeEnum.pillerArray:
                    // let isObsBelow = intersects.find((i)=> i.object.name.includes(meshTypeEnum.ObstacleExtrudeCap) || i.object.name.includes(meshTypeEnum.obstacleSetbackMesh));
                    this.cursorState = PanelArrayCursors.VALIDSINGLEPANELADD;
                    break;
                case meshTypeEnum.ObstacleExtrudeCap:
                case meshTypeEnum.obstacleSetbackMesh:
                    this.cursorState = PanelArrayCursors.VALIDSINGLEPANELADD;
                    break;
                
                default:
                    // When cursor is off the roof, keep cursor valid if we have a
                    // last-known roof so the panel can still be placed as long as it
                    // intersects the roof (overlap validated later).
                    this.cursorState = this.lastSinglePanelRoofPlane
                        ? PanelArrayCursors.VALIDSINGLEPANELADD
                        : PanelArrayCursors.INVALIDSINGLEPANELADD;
                    break;
            }
        } else {
            switch (namePrefix) {
                case meshTypeEnum.roofPlane:
                case meshTypeEnum.roofSetbackMesh:
                    if (nearestIntersect.parent?.name) {
                        const panelInstancedMesh = nearestIntersect.parent?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
                        this.cursorState = panelInstancedMesh ? PanelArrayCursors.INVALIDPANELARRAYADD : PanelArrayCursors.VALIDPANELARRAYADD;
                    }else{
                        this.cursorState = PanelArrayCursors.INVALIDSINGLEPANELADD;
                    }
                    break;
                default:
                    this.cursorState = PanelArrayCursors.INVALIDPANELARRAYADD;
                    break;
            }
        }
        this.engServ.updatePanelArrayCursorState(this.cursorState);
    }

    updateSinglePanelWhileDrawing(intersects: Intersection[], disableSnap = false) {
        const newintersects = intersects.filter(int => (int.object.name != meshTypeEnum.temporaryPanelMesh && !int.object.name.includes(meshTypeEnum.panel)&& !int.object.name.includes(meshTypeEnum.pillerArray)))
        let isHoveringOnSetback = false;
        let isHoveringOnObstacle = false;
        const intObj = newintersects[0]?.object;
        let roofPlane;
        switch (true) {
            case intObj?.name?.includes(meshTypeEnum.roofPlane):
                roofPlane = intObj as Mesh;
                break;
            case intObj?.name?.includes(meshTypeEnum.roofSetbackMesh):
                roofPlane = intObj.parent?.getObjectByName(meshTypeEnum.roofPlane) as Mesh;
                isHoveringOnSetback = true;
                break;
            case intObj?.parent?.name?.includes(meshTypeEnum.obstacleRootGroup):
                isHoveringOnObstacle= true;
                roofPlane = newintersects.find(i => i.object.name.includes(meshTypeEnum.roofPlane))?.object as Mesh;
                break;
            default:
              // place on last known roof
              if (this.lastSinglePanelRoofPlane && newintersects[0]?.point) {
                  roofPlane = this.lastSinglePanelRoofPlane;
              } else {
                  if (this.temporaryTransparentPanel) {
                      this.temporaryTransparentPanel.visible = false;
                  }
                  this.invalidSinglePanel = true;
                  this.guidesGroup.clear();
                  return;
              }
              break;
        }
        if (!roofPlane){
            if (this.temporaryTransparentPanel) {
                this.temporaryTransparentPanel.visible = false;
            }
            this.invalidSinglePanel = true;
            this.guidesGroup.clear();
            return;
        }

        // Switch roof if needed
        let isOnDifferentRoofWithoutPanels = false;
        if (this.lastSinglePanelRoofPlane
            && roofPlane.parent?.name
            && this.lastSinglePanelRoofPlane.parent?.name
            && roofPlane.parent.name !== this.lastSinglePanelRoofPlane.parent.name) {
            const newRoofInstancedMesh = roofPlane.parent.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
            if (!newRoofInstancedMesh) {
                roofPlane = this.lastSinglePanelRoofPlane;
                isOnDifferentRoofWithoutPanels = true;
            }
        }

        // remember this roof plane
        this.lastSinglePanelRoofPlane = roofPlane; 
      
        this.createOrUpdateTemporaryPanel(roofPlane, newintersects[0].point, disableSnap);

        const roofPlaneIntersection = newintersects.find(i => i.object.name.includes(meshTypeEnum.roofPlane))
            ?? { object: roofPlane } as unknown as Intersection;
        const collisionResult = this.isPanelPlacementValid(this.temporaryTransparentPanel!, roofPlaneIntersection);        

        if (collisionResult?.collidingWithPanel || collisionResult?.collidingWithRoof) {
                this.invalidSinglePanel = true;
                this.cursorState = PanelArrayCursors.INVALIDSINGLEPANELADD;
                this.engServ.updatePanelArrayCursorState(this.cursorState);
                if (this.temporaryTransparentPanel){
                    (this.temporaryTransparentPanel.material as MeshBasicMaterial).map = this.panelRedTexture.clone();
                }
        }else{
            if (isOnDifferentRoofWithoutPanels) {
                this.invalidSinglePanel = true;
                this.cursorState = PanelArrayCursors.INVALIDSINGLEPANELADD;
                this.engServ.updatePanelArrayCursorState(this.cursorState);
                if (this.temporaryTransparentPanel) {
                    (this.temporaryTransparentPanel.material as MeshBasicMaterial).map = this.panelRedTexture.clone();
                }
                return;
            }
            if(collisionResult?.collidingWithKeepout){
                if(collisionResult.collidingKeepout.name.includes(meshTypeEnum.roofPlane)){
                    this.invalidSinglePanel = true;
                    if (this.temporaryTransparentPanel){
                        (this.temporaryTransparentPanel.material as MeshBasicMaterial).map = this.panelRedTexture.clone();
                    }
                    return;
                }
                // A panel can never sit on a design component (the obstacle-height check below skips it).
                if ((collisionResult.collidingKeepout?.userData as MeshUserData)?.meshtype === storeIdPrefix.designComponent) {
                    this.invalidSinglePanel = true;
                    this.cursorState = PanelArrayCursors.INVALIDSINGLEPANELADD;
                    this.engServ.updatePanelArrayCursorState(this.cursorState);
                    if (this.temporaryTransparentPanel){
                        (this.temporaryTransparentPanel.material as MeshBasicMaterial).map = this.panelRedTexture.clone();
                    }
                    return;
                }
                let frameHeight = 0;
                this.store.select(fromPanelArraySelectors.selectedPanelArrayByRoofId((roofPlane.parent?.userData as MeshUserData).enactStoreId!)).pipe(take(1)).subscribe(panelArray => {  
                    frameHeight = Util.getMeasurementFeetToPixel( panelArray?.frameHeight ?? 0);
                  });
                const obstExtrudeCap =collisionResult.collidingKeepout?  collisionResult?.collidingKeepout.parent?.getObjectByName(meshTypeEnum.ObstacleExtrudeCap) as Mesh: (intersects.find(i => i.object.name.includes(meshTypeEnum.ObstacleExtrudeCap) || i.object.name.includes(meshTypeEnum.obstacleSetbackMesh)))?.object as Mesh;
                const obsId = (obstExtrudeCap?.parent?.userData as MeshUserData)?.enactStoreId!;
                let obs : Obstacle | undefined;
                if (obsId && obstExtrudeCap) {
                    this.store.select(fromObstacleSelectors.selectObstacleById(obsId)).pipe(take(1)).subscribe(o => {
                        obs = o;
                    })
                    if (obs?.type === ObstacleType.walkways) {
                        this.invalidSinglePanel = true;
                        (this.temporaryTransparentPanel!.material as MeshBasicMaterial).map = this.panelRedTexture.clone();
                    } else if (obs?.height == 0) {
                        this.invalidSinglePanel = false;
                        (this.temporaryTransparentPanel!.material as MeshBasicMaterial).map = this.panelYellowTexture.clone();
                    } else {
                        const obstVert = Util.getMeshVertices(obstExtrudeCap, true)
                        let maxHeight = -Infinity;
                        obstVert.forEach(vertex => {
                            maxHeight = Math.max(maxHeight, vertex.z);
                        });
                        const singlePanelvertes = Util.getMeshVertices(this.temporaryTransparentPanel!, true)
                        let minHeight = Infinity;
                        singlePanelvertes.forEach(vertex => {
                            minHeight = Math.min(minHeight, vertex.z - constants.SinglePanelOffzetZ);
                        });
                        if (minHeight + frameHeight > maxHeight) {
                            this.invalidSinglePanel = false;
                            (this.temporaryTransparentPanel!.material as MeshBasicMaterial).map = this.panelYellowTexture.clone();
                        } else {
                            this.invalidSinglePanel = true;
                            if (this.temporaryTransparentPanel) {
                                (this.temporaryTransparentPanel.material as MeshBasicMaterial).map = this.panelRedTexture.clone();
                            }
                            return;
                        }
                    }
                }
                
            }
            else if(isHoveringOnObstacle || collisionResult.collidingObstacleSetback){
                this.invalidSinglePanel = false;
                (this.temporaryTransparentPanel!.material as MeshBasicMaterial).map = this.panelYellowTexture.clone();
            }
            else if((collisionResult?.collidingWithSetback || isHoveringOnSetback) && this.temporaryTransparentPanel){
                this.invalidSinglePanel = false;
                (this.temporaryTransparentPanel.material as MeshBasicMaterial).map = this.panelYellowTexture.clone();
            }else{
                this.invalidSinglePanel = false;
                if (this.temporaryTransparentPanel){
                    (this.temporaryTransparentPanel.material as MeshBasicMaterial).map = this.panelWhiteTexture.clone();
                }
            }

        }

    }
    snapToClosestPanel(roofPlane: Mesh, temporaryTransparentPanel: Mesh, instancedMesh?: InstancedMesh ):boolean {
        const roofNormal = Util.getMeshNormal(roofPlane);
        const tempPanel = temporaryTransparentPanel?.clone();
        const tempPanelVertices = Util.getMeshVertices(tempPanel);
        [tempPanelVertices[2], tempPanelVertices[3]] = [tempPanelVertices[3], tempPanelVertices[2]];

        const allPanelArrays = instancedMesh 
            ? [instancedMesh] 
            : this.engServ.scene.getObjectsByProperty('name', meshTypeEnum.panelArray);
        const singlePanelCenter = Util.getCenter(tempPanel, true);
        const extendedTempPanelVertices = this.generateExtendedVertices(tempPanelVertices, 2);
        const raycaster = new Raycaster();
        let minDis = Infinity;
        let closestSnapProp;
        for (let i = 0; i < extendedTempPanelVertices.length; i++) {
            const v = extendedTempPanelVertices[i];
            raycaster.set(v.clone().setZ(0), new Vector3(0, 0, 1));
            const intersects = raycaster.intersectObjects(allPanelArrays, true);
            if(intersects.length>0 && intersects[0].instanceId!= undefined && InstancedMeshUtil.getVisibilityAt(intersects[0].object as InstancedMesh, intersects[0].instanceId)){
                const instanceId = intersects[0].instanceId;
                if(instanceId == undefined) return false;
                const panelArray = intersects[0].object as InstancedMesh;
                let panelObj : PanelArray | undefined;
                this.store.select(fromPanelArraySelectors.selectedPanelArrayByRoofId(roofPlane.parent?.name as string)).pipe(take(1)).subscribe(panelOb => {
                    panelObj = panelOb;
                });
                if(!panelObj) return false; 
                const panelArrayMatrix = new Matrix4();
                panelArray.getMatrixAt(instanceId, panelArrayMatrix);
                const panelWidthPx = Util.getMeasurementFeetToPixel(panelObj.panelWidth);
                const panelLengthPx = Util.getMeasurementFeetToPixel(panelObj.panelLength);
                const panelGeom = new PlaneGeometry(panelWidthPx, panelLengthPx)
                panelGeom.applyMatrix4(panelArrayMatrix);
                const panelCenter = Util.getCenter(new Mesh(panelGeom)).setZ(0);
                const distance = panelCenter.distanceTo(singlePanelCenter.clone().setZ(0));
                if(distance<minDis){
                    minDis = distance;
                    closestSnapProp = {panelGeom, panelWidthPx, panelLengthPx, panelObj};
                }
                
            }
            
        }
        if(closestSnapProp){
            const panelVertices = Util.getGeometryVertices(closestSnapProp.panelGeom);
            const panelCenter = Util.getCenter(new Mesh(closestSnapProp.panelGeom));
            const clampSpace = Util.getMeasurementFeetToPixel(closestSnapProp.panelObj.clampSpace);
            const frameSpace = Util.getMeasurementFeetToPixel(closestSnapProp.panelObj.frameSpace);
            const frameHeight = Util.getMeasurementFeetToPixel(closestSnapProp.panelObj.frameHeight - DefaultFrameValues.FRAMEHEIGHT);
            [panelVertices[2], panelVertices[3]] = [panelVertices[3], panelVertices[2]];

            let storeRoof: RoofSection | undefined;
            this.store.select(fromRoofSectionSelectors.selectRoofById([roofPlane.parent?.name as string])).pipe(take(1)).subscribe(roof => {
                storeRoof = roof[0];
            });
            if (!storeRoof) {return false;}

            const [edgeLeft, edgeRight] = this.storeUtil.GetRoofGutterVertices(storeRoof);
            if (!edgeLeft || !edgeRight) {
                return false;
            }
            const edgeVector = new Vector3().subVectors(edgeRight, edgeLeft).normalize();

            const singlePanelEdge1 = new Vector3().copy(panelVertices[0]).sub(panelVertices[1]);
            let projectPanelLength;
            let projectPanelWidth;
            let horizontalPanelVector;
            const crossLength = singlePanelEdge1.cross(edgeVector).length();
            
            const isPortrait = closestSnapProp.panelObj.orientation === PanelOrientation.portrait;
            const isRotated = this.isSinglePanelRotated;

            const singlepanelLength = isPortrait !== isRotated ? closestSnapProp.panelLengthPx : closestSnapProp.panelWidthPx;
            const singlepanelWidth = isPortrait !== isRotated ? closestSnapProp.panelWidthPx : closestSnapProp.panelLengthPx;
            
            if( crossLength < 0.1){
                
                projectPanelLength = (closestSnapProp.panelLengthPx/2 + singlepanelLength/2 +(clampSpace > 0 ? clampSpace : frameSpace))*Math.cos(Util.convertDegreeToRadian(closestSnapProp.panelObj.panelTilt));
                horizontalPanelVector = panelVertices[1].clone().sub(panelVertices[0]).normalize();
                projectPanelWidth = closestSnapProp.panelWidthPx/2 +singlepanelWidth/2+ (clampSpace > 0 ? clampSpace : frameSpace)
            }else{
                projectPanelLength = (closestSnapProp.panelWidthPx/2 + singlepanelLength/2+(clampSpace > 0 ? clampSpace : frameSpace))*Math.cos(Util.convertDegreeToRadian(closestSnapProp.panelObj.panelTilt));
                horizontalPanelVector = panelVertices[1].clone().sub(panelVertices[2]).normalize();
                projectPanelWidth = closestSnapProp.panelLengthPx/2 + singlepanelWidth/2+ (clampSpace > 0 ? clampSpace : frameSpace)
            }
            const verticalPanelVector = new Vector3().crossVectors(horizontalPanelVector, roofNormal).normalize();
            horizontalPanelVector.multiplyScalar(projectPanelWidth+Util.getMeasurementFeetToPixel(constants.PanlePlacementOffset)*Math.cos(Util.convertDegreeToRadian(closestSnapProp.panelObj.panelTilt)));
            verticalPanelVector.multiplyScalar(projectPanelLength +Util.getMeasurementFeetToPixel(constants.PanlePlacementOffset)*Math.cos(Util.convertDegreeToRadian(closestSnapProp.panelObj.panelTilt)));
            const positions = [
                panelCenter.clone().add(horizontalPanelVector),
                panelCenter.clone().add(verticalPanelVector),
                panelCenter.clone().sub(horizontalPanelVector),
                panelCenter.clone().sub(verticalPanelVector),
                panelCenter.clone().add(horizontalPanelVector).add(verticalPanelVector),
                panelCenter.clone().add(horizontalPanelVector).sub(verticalPanelVector),
                panelCenter.clone().sub(horizontalPanelVector).add(verticalPanelVector),
                panelCenter.clone().sub(horizontalPanelVector).sub(verticalPanelVector)
            ];
            // let minDistance = singlePanelCenter.distanceTo(positions[0]);
            // tempPanelVertices.push(tempPanelVertices[0])
            let minDistance = Infinity;
            let translateVec : Vector3 | undefined;
            for (let i = 0; i < positions.length; i++) {
                const distance = singlePanelCenter.clone().setZ(0).distanceTo(positions[i].clone().setZ(0));
                if (distance < minDistance) {
                    minDistance = distance;
                    translateVec = new Vector3().copy(positions[i]).sub(singlePanelCenter);
                }
            }
            temporaryTransparentPanel?.geometry.translate(translateVec!.x, translateVec!.y, translateVec!.z);
            const lowestPanelVertex = tempPanelVertices.sort((a, b) => a.z - b.z)[0];
            lowestPanelVertex.add(translateVec!);
            const newPlane = Util.getPlaneFromMesh(roofPlane);
            const projectedPoint = Util.projectPointOnPlane(lowestPanelVertex, newPlane);
            const panelHeightFromRoof = lowestPanelVertex.z - projectedPoint.z;
            const transalteZ = panelHeightFromRoof ? - panelHeightFromRoof: 0;
            temporaryTransparentPanel?.geometry.translate(0, 0, transalteZ);
            return true;
            // const matrix = this.temporaryTransparentPanel?.userData.matrix as Matrix4;
            // matrix.multiplyMatrices(matrix, new Matrix4().makeTranslation(translateVector.x, translateVector.y, 0));
            // this.temporaryTransparentPanel!.userData.matrix = matrix;
    }
    return false;
    }
    /**
 * Generates extended vertices from rectangle corners
 * @param {Array} corners - Array of 4 Vector3 points defining the rectangle corners
 * @param {number} distance - Distance to extend the points
 * @returns {Array} Array of 12 Vector3 points extending from the corners
 */
    generateExtendedVertices(corners: Vector3[], distance: number) {
        if (corners.length !== 4) {
            throw new Error("Input must contain exactly 4 corner points");
        }

        const extendedVertices = [];

        // For each corner
        for (let i = 0; i < 4; i++) {
            const corner = corners[i];
            const nextCorner = corners[(i + 1) % 4];
            const prevCorner = corners[(i + 3) % 4];

            // Calculate direction vectors
            const horizontalDir = new Vector3()
                .subVectors(corner, nextCorner)
                .normalize();

            const verticalDir = new Vector3()
                .subVectors(corner, prevCorner)
                .normalize();

            // Calculate diagonal direction (45° angle)
            const diagonalDir = new Vector3()
                .addVectors(horizontalDir, verticalDir)
                .normalize();

            // Create extended points
            const horizontalPoint = new Vector3()
                .copy(corner)
                .add(horizontalDir.multiplyScalar(distance));

            const verticalPoint = new Vector3()
                .copy(corner)
                .add(verticalDir.multiplyScalar(distance));

            const diagonalPoint = new Vector3()
                .copy(corner)
                .add(diagonalDir.multiplyScalar(distance));

            // Add to result array
            extendedVertices.push(horizontalPoint, verticalPoint, diagonalPoint, corner);
        }

        return extendedVertices;
    }

    // isObstacleRaycasted(intersects: Intersection[]) {
    //     return intersects.find(x => x.object.name.split('-').shift() === meshTypeEnum.ObstacleExtrudeCap
    //         || x.object.name.split('-').shift() == meshTypeEnum.obstacleRootGroup
    //         || x.object.name.split('-').shift() == meshTypeEnum.rectangleObstacle
    //         || x.object.name.split('-').shift() == meshTypeEnum.circleObstacle
    //         || x.object.name.split('-').shift() == meshTypeEnum.walkwaysObstacle
    //         || x.object.name.split('-').shift() == meshTypeEnum.obstacleSetbackMesh);
    // }

    updateRoofsSetbackVisbility(intersects: Intersection[], allRoofSections: RoofSection[]) {
        const roofPlane = intersects.find((intersect) => intersect.object.name === meshTypeEnum.roofPlane);
        if (roofPlane) {
            const selectedRoof = roofPlane.object.parent;
            if (selectedRoof) {
                const roofSetbackMesh = selectedRoof.getObjectByName(meshTypeEnum.roofSetbackMesh);
                if (roofSetbackMesh) roofSetbackMesh.visible = true;
            }
        } else {
            allRoofSections.forEach((roofSection) => {
                const roof = this.engServ.scene.getObjectByName(roofSection.id);
                if (!roof) return;
                const roofSetbackMesh = roof.getObjectByName(meshTypeEnum.roofSetbackMesh);
                if (roofSetbackMesh) roofSetbackMesh.visible = roofSection.setbackVisible;
            });
        }
    }

    isSetbacksRaycasted(intersects: Intersection[]) {
        return intersects.find(x => x.object.name.split('-').shift() == meshTypeEnum.roofSetbackMesh
            || x.object.name.split('-').shift() == meshTypeEnum.obstacleSetbackMesh);
    }

    ifRoofHasPanels(selectedRoofId: string) {
        let result = false;
        this.store.select(fromPanelArraySelectors.selectPanelArraysByRoofId(selectedRoofId))
            .pipe(take(1))
            .subscribe(roofPanelArrays => {
                result = roofPanelArrays.length > 0;
            })
        return result;
    }

    checkIfDrawPanelsInSelectedArea(roofId: string, globalToLocal: Matrix4, polygonPoints: Vector3[], panelArrayId: string) {
        let result = false;
        const polygonPoints2D = Util.convertPolygonPointsTo2D(polygonPoints, globalToLocal);
        this.store.select(fromPanelArraySelectors.selectPanelArraysByRoofId(roofId))
            .pipe(take(1))
            .subscribe(roofPanelArrays => {
                roofPanelArrays.forEach(r => {
                    if (r.id === panelArrayId) return;
                    const vertices = this.GetPanelArrayBoundaryVertices(r)
                    const existingPanels2D = Util.convertPolygonPointsTo2D(vertices, globalToLocal);
                    existingPanels2D.forEach(ev => {
                        if (CollisionUtil.isPointInPolygon(polygonPoints2D, ev)) {
                            result = true;
                            return;
                        }
                    })
                    if (!result) {
                        const edgeIntersects = polygonPoints2D.some((pPt, i) => {
                            if (i < polygonPoints2D.length - 1) {
                                const panelEdgePts = [pPt, polygonPoints2D[i + 1]]

                                const intersects = existingPanels2D.some((kPt, k) => {
                                    if (k < existingPanels2D.length - 1) {
                                        const keepoutEdgePts = [kPt, existingPanels2D[k + 1]];
                                        const edgeIntPts = CollisionUtil.intersectLines(panelEdgePts, keepoutEdgePts);
                                        if (edgeIntPts) return true;
                                    }

                                    return false;
                                })
                                return intersects;
                            }
                            return false;
                        })
                        result = edgeIntersects == true;
                    }
                });
            })
        return result;
    }


    convertNonInstancedToInstanced(panelArray: Group) {
        const panelArrayId = panelArray.name;
        let storePanelArray: PanelArray | undefined;
        this.store.select(fromPanelArraySelectors.selectPanelArraysByIds([panelArrayId])).pipe((take(1))).subscribe(arrays => {
            if (!arrays || arrays.length <= 0) return;
            storePanelArray = arrays[0];
        });
        if (!storePanelArray) return;
        const panelUserDataArr: MeshUserData[] = [];
        const panelM = new MeshStandardMaterial({
            map: new Texture(),
            side: DoubleSide,
            transparent: true,
        });
        const roof = this.engServ.scene.getObjectByName(storePanelArray.roofId) as Mesh | undefined;
        if (!roof) {
            throw new Error(`Roof with ID ${storePanelArray.roofId} not found`);
        }

        const roofPlane = roof.getObjectByName(meshTypeEnum.roofPlane) as Mesh | undefined; 
        if (!roofPlane) {
            throw new Error(`Roof plane not found in roof with ID ${storePanelArray.roofId}`);
        }

        const panelWidth = Util.getMeasurementFeetToPixel(storePanelArray?.panelWidth ?? 0);
        const panelLength = Util.getMeasurementFeetToPixel(storePanelArray?.panelLength ?? 0);
        const panelGeom = new PlaneGeometry(panelWidth, panelLength);

        const roofPlaneArea = Util.calculateArea(roofPlane);
        const panelTilt = storePanelArray?.panelTilt ?? 0;
        const maxPossiblePanels = this.calculateMaxPossiblePanels(panelGeom, roofPlaneArea, panelTilt, storePanelArray.roofTilt);

        const instancedMesh = new InstancedMesh(panelGeom, panelM, maxPossiblePanels); //Making count sufficiently large to accomodate single panels
        InstancedMeshUtil.init(instancedMesh);
        InstancedMeshUtil.setPanelShader(instancedMesh);
        instancedMesh.name = meshTypeEnum.panelArray;
        (instancedMesh.userData as MeshUserData).meshtype = meshTypeEnum.instancedMesh;
        (instancedMesh.userData as MeshUserData).maxInstanceCount = instancedMesh.count;

        (panelArray.children[0].children as Mesh[]).forEach((pM: Mesh, i: number) => {
            // pM.position.setZ(0);
            const panelNormal = Util.getMeshNormal(pM);
            if (panelNormal.z < 0) panelNormal.negate();
            const panelVertices = Util.getMeshVertices(pM, true);
            const panelAzim = new Vector3().copy(panelVertices[0]).sub(panelVertices[1]).normalize();
            const panelCenter = Util.getCenter(pM);
            const q1 = new Quaternion().setFromUnitVectors(new Vector3(0, 0, 1), panelNormal);
            const q2 = new Quaternion().setFromUnitVectors(new Vector3(1, 0, 0).applyQuaternion(q1), panelAzim);


            const tempObj = new Mesh();
            if (storePanelArray?.orientation == PanelOrientation.landscape) {
                tempObj.rotateOnAxis(new Vector3(0, 0, 1), Math.PI / 2);
            }
            tempObj.applyQuaternion(q1);
            tempObj.applyQuaternion(q2);
            tempObj.position.add(panelCenter);
            tempObj.updateMatrix();
            tempObj.updateMatrixWorld();

            instancedMesh.setMatrixAt(i, tempObj.matrixWorld);
            instancedMesh.setColorAt(i, new Color(0xffffff));
            InstancedMeshUtil.setVisibilityAt(instancedMesh, i, pM.visible);
            const pU = {
                matrix: tempObj.matrix,
                instanceId: i,
                enactStoreId: pM.name,
                visible: pM.visible,
                azimuth: pM.userData.azimuth,
                frameId: pM.userData.frameId,
                // ori
            }
            panelUserDataArr.push(pU as any);
        });
        instancedMesh.count = storePanelArray.totalAddedPanels;
        instancedMesh.renderOrder = renderOrders.panelArray;
        panelArray.clear();
        panelArray.add(instancedMesh);
        this.addInstacneIdsToOldPanelsStore(panelUserDataArr);
    }

    addInstacneIdsToOldPanelsStore(panelUserDataArr: MeshUserData[]) {
      const panelIds = panelUserDataArr.map((p) => p.enactStoreId!);
      this.store
        .select(fromPanelSelectors.selectPanelsByIds(panelIds))
        .pipe(take(1))
        .subscribe((storePanels) => {
          const newstorePanels: Panel[] = JSON.parse(JSON.stringify(storePanels));

          for (let i = 0; i < storePanels.length; i++) {
            newstorePanels[i].instanceId = panelUserDataArr.find(
              (x) => x.enactStoreId == storePanels[i]!.id
            )?.instanceId!;
          }
          this.store.dispatch(
            fromPanelActions.UpsertMany({ panels: newstorePanels })
          );
        });
    }

    /**
     * Async version of validateAndFixVisibilitySync that returns a Promise
     */
    async validateAndFixVisibilitySyncAsync(): Promise<void> {
        await this.waitForOperationCompletion();
        return new Promise((resolve) => {
            try {
                this.store.select(fromPanelArraySelectors.allPanelArrays).pipe(take(1)).subscribe(allPanelArrays => {
                    const syncPromises = allPanelArrays.map(async (panelArray) => {
                        const roofObj = this.engServ.scene.getObjectByName(panelArray.roofId);
                        if (roofObj) {
                            const panelArrayGroup = roofObj.getObjectByName(panelArray.id);
                            const panelInstanceMesh = panelArrayGroup?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
                            
                            if (panelInstanceMesh) {
                                await this.syncStoreVisibilityWithSceneAsync(panelInstanceMesh, panelArray);
                            }
                        }
                    });
                    
                    Promise.all(syncPromises).then(() => resolve());
                });
            } catch (error) {
                console.error('Error validating panel visibility sync:', error);
                resolve(); // Don't block execution on error
            }
        });
    }

    /**
     * Validates and fixes any visibility mismatches between scene and store for all panel arrays
     * can be called after any operation that might affect panel visibility
     */
    validateAndFixVisibilitySync() {
        try {
            this.store.select(fromPanelArraySelectors.allPanelArrays).pipe(take(1)).subscribe(allPanelArrays => {
                allPanelArrays.forEach(panelArray => {
                    const roofObj = this.engServ.scene.getObjectByName(panelArray.roofId);
                    if (roofObj) {
                        const panelArrayGroup = roofObj.getObjectByName(panelArray.id);
                        const panelInstanceMesh = panelArrayGroup?.getObjectByName(meshTypeEnum.panelArray) as InstancedMesh;
                        
                        if (panelInstanceMesh) {
                            this.syncStoreVisibilityWithScene(panelInstanceMesh, panelArray);
                        }
                    }
                });
            });
        } catch (error) {
            console.error('Error validating panel visibility sync:', error);
        }
    }

    /**
     * Computes the fraction of the panel's area that overlaps with the roof polygon.
     * Uses the Sutherland–Hodgman algorithm to clip the panel polygon against the roof
     * polygon, then compares the clipped area to the original panel area.
     *
     * @param panelVertices  The 4 world-space vertices of the panel (in 2D x/y)
     * @param roofPolygon    The roof boundary vertices (in 2D x/y)
     * @returns A ratio in [0, 1] where 1 means the panel is fully inside the roof
     */
    private computePanelRoofOverlapRatio(panelVertices: Vector3[], roofPolygon: Vector3[]): number {
        const toVec2 = (verts: Vector3[]) => verts.map(v => new Vector2(v.x, v.y));
        const panelArea = Util.calcPolygonArea(toVec2(panelVertices));
        if (panelArea <= 0) return 0;

        // Ensure both polygons are in counter-clockwise winding order
        const ccwPanel = this.ensureCCW(panelVertices);
        const ccwRoof = this.ensureCCW(roofPolygon);

        let totalClippedArea = 0;
        if (this.isPolygonConvex(ccwRoof)) {
            const clipped = this.sutherlandHodgmanClip(ccwPanel, ccwRoof);
            if (clipped.length >= 3) {
                totalClippedArea = Util.calcPolygonArea(toVec2(clipped));
            }
        } else {
            const triangles = this.triangulatePolygon(ccwRoof);
            for (const tri of triangles) {
                const clipped = this.sutherlandHodgmanClip(ccwPanel, tri);
                if (clipped.length >= 3) {
                    totalClippedArea += Util.calcPolygonArea(toVec2(clipped));
                }
            }
        }

        return Math.min(totalClippedArea / panelArea, 1);
    }

    private isPolygonConvex(vertices: Vector3[]): boolean {
        const n = vertices.length;
        if (n < 3) return false;
        for (let i = 0; i < n; i++) {
            const a = vertices[i];
            const b = vertices[(i + 1) % n];
            const c = vertices[(i + 2) % n];
            const cross = (b.x - a.x) * (c.y - b.y) - (b.y - a.y) * (c.x - b.x);
            if (cross < 0) return false; 
        }
        return true;
    }

    private triangulatePolygon(vertices: Vector3[]): Vector3[][] {
        const triangles: Vector3[][] = [];
        const indices = vertices.map((_, i) => i);

        while (indices.length > 3) {
            let earFound = false;
            for (let i = 0; i < indices.length; i++) {
                const prevIdx = indices[(i + indices.length - 1) % indices.length];
                const currIdx = indices[i];
                const nextIdx = indices[(i + 1) % indices.length];

                const a = vertices[prevIdx];
                const b = vertices[currIdx];
                const c = vertices[nextIdx];

                // Only convex (left-turn) vertices can be ears
                const cross = (b.x - a.x) * (c.y - b.y) - (b.y - a.y) * (c.x - b.x);
                if (cross < 0) continue;

                // Make sure no other vertex lies inside this candidate ear
                let hasPointInside = false;
                for (let j = 0; j < indices.length; j++) {
                    const idx = indices[j];
                    if (idx === prevIdx || idx === currIdx || idx === nextIdx) continue;
                    if (this.isPointInTriangle(vertices[idx], a, b, c)) {
                        hasPointInside = true;
                        break;
                    }
                }

                if (!hasPointInside) {
                    triangles.push([a, b, c]);
                    indices.splice(i, 1);
                    earFound = true;
                    break;
                }
            }
            if (!earFound) break; // degenerate polygon – bail out
        }

        if (indices.length === 3) {
            triangles.push([vertices[indices[0]], vertices[indices[1]], vertices[indices[2]]]);
        }
        return triangles;
    }

    /**
     * Returns true when point p is inside (or on the boundary of) triangle abc
     * (vertices in CCW order) using cross-product half-plane tests.
     */
    private isPointInTriangle(p: Vector3, a: Vector3, b: Vector3, c: Vector3): boolean {
        const cross1 = (b.x - a.x) * (p.y - a.y) - (b.y - a.y) * (p.x - a.x);
        const cross2 = (c.x - b.x) * (p.y - b.y) - (c.y - b.y) * (p.x - b.x);
        const cross3 = (a.x - c.x) * (p.y - c.y) - (a.y - c.y) * (p.x - c.x);
        return cross1 >= 0 && cross2 >= 0 && cross3 >= 0;
    }

     // Ensures a polygon vertices are in counter-clockwise winding order.
     // If they are clockwise, the array is reversed.
    private ensureCCW(vertices: Vector3[]): Vector3[] {
        // Compute signed shoelace area inline: positive = CCW, negative = CW
        let signedArea = 0;
        for (let i = 0; i < vertices.length; i++) {
            const j = (i + 1) % vertices.length;
            signedArea += vertices[i].x * vertices[j].y;
            signedArea -= vertices[j].x * vertices[i].y;
        }
        // Negative signed area means clockwise in standard XY — reverse to get CCW
        if (signedArea < 0) {
            return [...vertices].reverse();
        }
        return vertices;
    }

    //Sutherland–Hodgman polygon clipping algorithm.
    // Both polygons must be in counter-clockwise winding order in the XY plane.
    private sutherlandHodgmanClip(subjectPolygon: Vector3[], clipPolygon: Vector3[]): Vector3[] {
        let output: Vector3[] = [...subjectPolygon];

        for (let i = 0; i < clipPolygon.length && output.length > 0; i++) {
            const input = output;
            output = [];
            const edgeStart = clipPolygon[i];
            const edgeEnd = clipPolygon[(i + 1) % clipPolygon.length];

            for (let j = 0; j < input.length; j++) {
                const current = input[j];
                const previous = input[(j + input.length - 1) % input.length];
                const currInside = this.isInsideEdge(current, edgeStart, edgeEnd);
                const prevInside = this.isInsideEdge(previous, edgeStart, edgeEnd);

                if (currInside) {
                    if (!prevInside) {
                        const intersection = this.lineIntersection2D(previous, current, edgeStart, edgeEnd);
                        if (intersection) output.push(intersection);
                    }
                    output.push(current);
                } else if (prevInside) {
                    const intersection = this.lineIntersection2D(previous, current, edgeStart, edgeEnd);
                    if (intersection) output.push(intersection);
                }
            }
        }
        return output;
    }

    // Returns true if point is on the left (inside) side of the directed edge from edgeStart to edgeEnd
    private isInsideEdge(point: Vector3, edgeStart: Vector3, edgeEnd: Vector3): boolean {
        return (edgeEnd.x - edgeStart.x) * (point.y - edgeStart.y) -
               (edgeEnd.y - edgeStart.y) * (point.x - edgeStart.x) >= 0;
    }

    // Computes the intersection point of two 2D lines
    private lineIntersection2D(p1: Vector3, p2: Vector3, p3: Vector3, p4: Vector3): Vector3 | null {
        const dx1 = p2.x - p1.x, dy1 = p2.y - p1.y;
        const dx2 = p4.x - p3.x, dy2 = p4.y - p3.y;
        const denom = dx1 * dy2 - dy1 * dx2;
        if (Math.abs(denom) < 1e-10) return null;
        const t = ((p3.x - p1.x) * dy2 - (p3.y - p1.y) * dx2) / denom;
        return new Vector3(p1.x + t * dx1, p1.y + t * dy1, 0);
    }

    translateMsg(val: string, isToasterMsg = true) {
        let translatedName = '';
        let toasterPrefix = '';
        if(isToasterMsg){
          toasterPrefix = 'toastrMsgs.';
        }

        this.translate.get( toasterPrefix + val).pipe(take(1)).subscribe(res => {
          translatedName = res;
        }).unsubscribe();
        return translatedName;
    }
}

